import {
  Box,
  Button,
  Card,
  CardActionArea,
  Checkbox,
  Collapse,
  Dialog,
  Divider,
  Fade,
  Grid,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import Minus from 'assets/images/Minus.png';
import Plus from 'assets/images/Plus.png';
import staricon from 'assets/images/star.png';
import { ReactComponent as Sound } from 'assets/svg/Sound.svg';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import 'index.css';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { poppins300, poppins400, poppins500 } from 'theme/common.style';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
  makeOfferRequest,
  Moxoseparationinlisting,
  postApiCall,
  formatDateTimeSydney,
} from 'api/apiService';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useTheme } from '@emotion/react';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { MakeOfferLabel } from './MarketplaceMakeoffer';
import SubmitOfferPopup from 'component/BuyersMarketplace/SubmitOfferPopup';
import OffersSection from './OffersSection';
import {
  BUYER_REQUESTSTAGE2,
  DELETE_AUTO_OFFER,
  EDIT_AUTO_OFFER,
  BUYER_OFFERCANCEL,
} from 'constant/app.config';
import Fab from '@mui/material/Fab';
import CheckIcon from '@mui/icons-material/Check';
import { green } from '@mui/material/colors';
import { Line } from 'react-chartjs-2';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ConditionalTerms from './ConditionalTerms';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import IdenticalSuggestion from 'modules/BuyerMarketplace/IdenticalSuggestion';
import useSound from 'use-sound';
import CampaignRestrictedPopup from 'component/BuyersMarketplace/CampaignRestrictedPopup';
import dayjs from 'dayjs';
import KeyboardReturnRoundedIcon from '@mui/icons-material/KeyboardReturnRounded';
import Loading from 'assets/images/loading.png';
import MeterChartOffer from 'component/BuyerRegistration/MeterChartOffer';
import OfferInput from './OfferInput';
import ConfirmingParticipationStageTwo from './ConfirmingParticipationStageTwo';

const HighStar = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 0L5.75152 2.99803L9 3.43769L6.47146 5.50106L7.28115 9L4.5 7.04803L1.71885 9L2.52848 5.50106L0 3.43769L3.24848 2.99803L4.5 0Z"
        fill="white"
      />
    </svg>
  );
};
export const LockIconSharePage = () => {
  return (
    <svg
      width="54"
      height="64"
      viewBox="0 0 54 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.44204 48.4142C4.19139 55.0248 9.78193 60.1798 16.4311 60.4157C19.8039 60.5351 23.2672 60.5973 26.9999 60.5973C30.7326 60.5973 34.1958 60.5351 37.5687 60.4157C44.218 60.1798 49.8084 55.0248 50.5576 48.4142C50.8189 46.1098 51 43.7685 51 41.3972C51 39.0258 50.8189 36.6846 50.5576 34.3803C49.8084 27.7693 44.218 22.6147 37.5687 22.3788C34.1958 22.2591 30.7326 22.1973 26.9999 22.1973C23.2672 22.1973 19.8039 22.2591 16.4311 22.3788C9.78189 22.6147 4.19139 27.7693 3.44204 34.3803C3.18082 36.6846 3 39.0258 3 41.3972C3 43.7685 3.18082 46.1098 3.44204 48.4142Z"
        fill="#D7E0FF"
        stroke="#4147D5"
        stroke-width="5"
      />
      <path
        d="M40.4268 22.1999V16.44C40.4268 12.8755 39.0107 9.45693 36.4903 6.93646C33.9698 4.41599 30.5513 3 26.9868 3C23.4223 3 20.0039 4.41599 17.4834 6.93646C14.9629 9.45693 13.5469 12.8755 13.5469 16.44V22.1999"
        stroke="#4147D5"
        stroke-width="5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M27.01 47.1625C30.1911 47.1625 32.77 44.5837 32.77 41.4026C32.77 38.2214 30.1911 35.6426 27.01 35.6426C23.8288 35.6426 21.25 38.2214 21.25 41.4026C21.25 44.5837 23.8288 47.1625 27.01 47.1625Z"
        fill="#4147D5"
      />
    </svg>
  );
};
export const WarningIcon = () => {
  return (
    <svg
      width="19"
      height="16"
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.4617 11.4607L12.2221 1.45599C11.6599 0.555115 10.6211 0 9.49654 0C8.37203 0 7.33324 0.555115 6.77099 1.45599L0.421689 11.632C-0.140563 12.5329 -0.140563 13.6431 0.421689 14.544C0.983941 15.4449 2.02274 16 3.14724 16H15.8459C15.8494 16 15.8528 16 15.8528 16C17.5909 16 19 14.6962 19 13.088C19 12.4853 18.8012 11.9239 18.4617 11.4607ZM10.8439 12.4345C10.8439 13.1229 10.2714 13.6495 9.5 13.6495C8.72862 13.6495 8.15608 13.1229 8.15608 12.4345V12.406C8.15608 11.7208 8.72862 11.1911 9.5 11.1911C10.2714 11.1911 10.8439 11.7177 10.8439 12.406V12.4345ZM10.8748 4.24425L10.2097 9.61776C10.1651 10.0048 9.88741 10.2458 9.5 10.2458C9.1126 10.2458 8.8349 10.0016 8.79033 9.61776L8.12523 4.24108C8.08066 3.82554 8.32411 3.5115 8.74233 3.5115H10.2542C10.6725 3.51467 10.9193 3.82871 10.8748 4.24425Z"
        fill="#FF3B30"
      />
    </svg>
  );
};
export const AutoOfferWaring = () => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.0817 11.9607L11.3085 1.95599C10.7883 1.05512 9.82712 0.5 8.78664 0.5C7.7462 0.5 6.78506 1.05512 6.26484 1.95599L0.390166 12.132C-0.130056 13.0329 -0.130056 14.1431 0.390166 15.044C0.910388 15.9449 1.87153 16.5 2.91197 16.5H14.6614C14.6646 16.5 14.6677 16.5 14.6677 16.5C16.276 16.5 17.5797 15.1962 17.5797 13.588C17.5797 12.9853 17.3957 12.4239 17.0817 11.9607ZM10.0333 12.9345C10.0333 13.6229 9.50357 14.1495 8.78985 14.1495C8.07613 14.1495 7.54639 13.6229 7.54639 12.9345V12.906C7.54639 12.2208 8.07613 11.6911 8.78985 11.6911C9.50357 11.6911 10.0333 12.2177 10.0333 12.906V12.9345ZM10.0619 4.74425L9.44647 10.1178C9.40523 10.5048 9.14829 10.7458 8.78985 10.7458C8.4314 10.7458 8.17446 10.5016 8.13323 10.1178L7.51784 4.74108C7.47661 4.32554 7.70186 4.0115 8.08882 4.0115H9.48771C9.8747 4.01467 10.1031 4.32871 10.0619 4.74425Z"
        fill="#F39800"
      />
    </svg>
  );
};
const FocusModeIocnBlack = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 0L24.002 6.124C27.5264 6.56958 30.8025 8.17486 33.3143 10.687C35.8261 13.1992 37.4309 16.4755 37.876 20H44V24L37.876 24.002C37.4305 27.5261 35.8255 30.802 33.3138 33.3138C30.802 35.8255 27.5261 37.4305 24.002 37.876L24 44H20V37.876C16.4755 37.4309 13.1992 35.8261 10.687 33.3143C8.17486 30.8025 6.56958 27.5264 6.124 24.002L0 24V20H6.124C6.56917 16.4752 8.17427 13.1987 10.6865 10.6865C13.1987 8.17427 16.4752 6.56917 20 6.124V0H24ZM22 10C18.8174 10 15.7652 11.2643 13.5147 13.5147C11.2643 15.7652 10 18.8174 10 22C10 25.1826 11.2643 28.2348 13.5147 30.4853C15.7652 32.7357 18.8174 34 22 34C25.1826 34 28.2348 32.7357 30.4853 30.4853C32.7357 28.2348 34 25.1826 34 22C34 18.8174 32.7357 15.7652 30.4853 13.5147C28.2348 11.2643 25.1826 10 22 10ZM22 18C23.0609 18 24.0783 18.4214 24.8284 19.1716C25.5786 19.9217 26 20.9391 26 22C26 23.0609 25.5786 24.0783 24.8284 24.8284C24.0783 25.5786 23.0609 26 22 26C20.9391 26 19.9217 25.5786 19.1716 24.8284C18.4214 24.0783 18 23.0609 18 22C18 20.9391 18.4214 19.9217 19.1716 19.1716C19.9217 18.4214 20.9391 18 22 18Z"
        fill="black"
      />
    </svg>
  );
};

const EditIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.11642 13.1298L14.7142 1.53204C14.7331 1.52637 14.7536 1.52047 14.7757 1.51449C14.9346 1.47143 15.1639 1.42662 15.433 1.42291C15.9511 1.41576 16.6387 1.55681 17.314 2.2321C17.9893 2.90739 18.1303 3.59493 18.1232 4.11311C18.1195 4.38215 18.0746 4.61143 18.0316 4.77036C18.0256 4.79246 18.0197 4.81299 18.014 4.83188L6.41625 16.4297L2.66644 16.8796L3.11642 13.1298Z"
        stroke="#666666"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M11.8906 2.94141L16.3802 7.43097"
        stroke="#666666"
        stroke-width="2"
      />
    </svg>
  );
};
const DeleteIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 5.16797H18.5L17.9875 15.4177C17.8545 18.0787 15.6581 20.168 12.9938 20.168H9.00625C6.34188 20.168 4.14554 18.0787 4.01248 15.4177L3.5 5.16797Z"
        stroke="#666666"
        stroke-width="2"
      />
      <path
        d="M6.83203 5.16797V4.83463C6.83203 3.17778 8.17518 1.83464 9.83203 1.83464H12.1654C13.8222 1.83464 15.1654 3.17778 15.1654 4.83463V5.16797"
        stroke="#666666"
        stroke-width="2"
      />
      <path
        d="M1.83203 5.16797H20.1654"
        stroke="#666666"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M13.5 10.168V14.3346"
        stroke="#666666"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        d="M8.5 10.168V14.3346"
        stroke="#666666"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};
const EyeCloseIcon = () => {
  return (
    <svg
      width="19"
      height="15"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.96536 0.270179C3.60512 -0.0900596 3.02105 -0.0900596 2.6608 0.270179C2.30057 0.630427 2.30057 1.21449 2.6608 1.57474L15.5752 14.4892C15.9355 14.8494 16.5196 14.8494 16.8798 14.4892C17.24 14.1289 17.24 13.5448 16.8798 13.1846L15.5208 11.8256C16.9392 10.6935 18.0162 9.1518 18.5728 7.37963C17.3973 3.63714 13.9009 0.922459 9.77048 0.922459C8.27282 0.922459 6.8585 1.27938 5.60797 1.91279L3.96536 0.270179ZM7.89598 4.20079L9.29247 5.59729C9.44494 5.5565 9.60519 5.53475 9.77057 5.53475C10.7894 5.53475 11.6155 6.36075 11.6155 7.37967C11.6155 7.54497 11.5937 7.7053 11.5529 7.85769L12.9494 9.2542C13.2741 8.70487 13.4604 8.06404 13.4604 7.37967C13.4604 5.34183 11.8084 3.68983 9.77057 3.68983C9.08618 3.68983 8.44534 3.87614 7.89598 4.20079Z"
        fill="#C4C4C4"
      />
      <path
        d="M12.0307 13.5572L9.536 11.0625C7.6823 10.9479 6.19905 9.46458 6.08446 7.6109L2.69622 4.22266C1.92662 5.14022 1.33231 6.20977 0.964844 7.37973C2.14031 11.1222 5.63669 13.8369 9.76712 13.8369C10.5482 13.8369 11.3064 13.7399 12.0307 13.5572Z"
        fill="#C4C4C4"
      />
    </svg>
  );
};

export const Sign = (props) => {
  let { matchessm, isSmallHeight } = props;
  return (
    <svg
      width={isSmallHeight ? '150px' : matchessm ? '200px' : '309'}
      height={isSmallHeight ? '150px' : matchessm ? '200px' : '309'}
      viewBox="0 0 309 309"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.7">
        <mask id="path-1-inside-1_19914_125757" fill="white">
          <path d="M309 154.5C309 239.828 239.828 309 154.5 309C69.172 309 0 239.828 0 154.5C0 69.172 69.172 0 154.5 0C239.828 0 309 69.172 309 154.5ZM23.0339 154.5C23.0339 227.107 81.8933 285.966 154.5 285.966C227.107 285.966 285.966 227.107 285.966 154.5C285.966 81.8933 227.107 23.0339 154.5 23.0339C81.8933 23.0339 23.0339 81.8933 23.0339 154.5Z" />
        </mask>

        <path
          d="M309 154.5C309 239.828 239.828 309 154.5 309C69.172 309 0 239.828 0 154.5C0 69.172 69.172 0 154.5 0C239.828 0 309 69.172 309 154.5ZM23.0339 154.5C23.0339 227.107 81.8933 285.966 154.5 285.966C227.107 285.966 285.966 227.107 285.966 154.5C285.966 81.8933 227.107 23.0339 154.5 23.0339C81.8933 23.0339 23.0339 81.8933 23.0339 154.5Z"
          fill="white"
          stroke="#6C2AD2"
          stroke-width="50"
          mask="url(#path-1-inside-1_19914_125757)"
        />
      </g>
      <path
        class="Tick"
        d="M75 170L129 210L224 90"
        stroke="#6C2AD2"
        stroke-width="30"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const CloseIcon = () => {
  return (
    <svg
      width="109"
      height="109"
      viewBox="0 0 109 109"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4351 2.13351C9.59037 -0.711171 4.97824 -0.711171 2.1335 2.13351C-0.711166 4.97827 -0.711166 9.59043 2.1335 12.4352L44.1983 54.5001L2.13394 96.5651C-0.710729 99.4096 -0.710729 104.022 2.13394 106.867C4.97868 109.711 9.5908 109.711 12.4355 106.867L54.4998 64.8017L96.5644 106.867C99.4089 109.711 104.021 109.711 106.866 106.867C109.71 104.022 109.71 99.4096 106.866 96.5651L64.8012 54.5001L106.867 12.4352C109.711 9.59043 109.711 4.97827 106.867 2.13351C104.022 -0.711171 99.4097 -0.711171 96.5651 2.13351L54.4998 44.1986L12.4351 2.13351Z"
        fill="#D82828"
      />
    </svg>
  );
};

const Ellipse = ({ isSmallHeight }) => (
  <svg
    width={isSmallHeight ? '150' : '309'}
    height={isSmallHeight ? '150' : '309'}
    viewBox="0 0 309 309"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.7">
      <mask id="path-1-inside-1_21579_63401" fill="white">
        <path d="M309 154.5C309 239.828 239.828 309 154.5 309C69.172 309 0 239.828 0 154.5C0 69.172 69.172 0 154.5 0C239.828 0 309 69.172 309 154.5ZM23.0339 154.5C23.0339 227.107 81.8933 285.966 154.5 285.966C227.107 285.966 285.966 227.107 285.966 154.5C285.966 81.8933 227.107 23.0339 154.5 23.0339C81.8933 23.0339 23.0339 81.8933 23.0339 154.5Z" />
      </mask>
      <path
        d="M309 154.5C309 239.828 239.828 309 154.5 309C69.172 309 0 239.828 0 154.5C0 69.172 69.172 0 154.5 0C239.828 0 309 69.172 309 154.5ZM23.0339 154.5C23.0339 227.107 81.8933 285.966 154.5 285.966C227.107 285.966 285.966 227.107 285.966 154.5C285.966 81.8933 227.107 23.0339 154.5 23.0339C81.8933 23.0339 23.0339 81.8933 23.0339 154.5Z"
        fill="white"
        stroke="#D82828"
        strokeWidth="50"
        mask="url(#path-1-inside-1_21579_63401)"
      />
    </g>
    <foreignObject width="100%" height="100%">
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <CloseIcon />
      </div>
    </foreignObject>
  </svg>
);
export const Redwarning = () => {
  return (
    <svg
      width="38"
      height="36"
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37.5797"
        height="36"
        rx="18"
        fill="#F93939"
        fill-opacity="0.1"
      />
      <path
        d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
        fill="#F93939"
      />
    </svg>
  );
};
export const Pendingwarning = () => {
  return (
    <svg
      width="38"
      height="36"
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37.5797"
        height="36"
        rx="18"
        fill="#F39800"
        fill-opacity="0.1"
      />
      <path
        d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
        fill="#F39800"
      />
    </svg>
  );
};

export const Warning = ({ matchesmd }) => {
  return (
    <svg
      width={matchesmd ? '25' : '38'}
      height={matchesmd ? '24' : '36'}
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37.5797"
        height="36"
        rx="18"
        fill="#10D35E"
        fill-opacity="0.1"
      />
      <path
        d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
        fill="#10D35E"
      />
    </svg>
  );
};

const Message = ({ color = '' }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_16101_162212)">
        <path
          d="M21.3198 0.68023C21.1458 0.50616 20.8847 0.452634 20.6563 0.544017L0.886757 8.45173C0.660556 8.54221 0.509086 8.75763 0.50039 9.00114C0.491736 9.2446 0.62758 9.47023 0.846767 9.57654L8.64251 13.3574L12.4234 21.1531C12.5265 21.3658 12.7418 21.4999 12.9768 21.4999C12.9841 21.4999 12.9915 21.4998 12.9988 21.4995C13.2422 21.4909 13.4577 21.3394 13.5482 21.1132L21.456 1.34378C21.5474 1.11524 21.4938 0.854259 21.3198 0.68023ZM2.63664 9.07705L18.3303 2.79967L8.97752 12.1523L2.63664 9.07705ZM12.9229 19.3633L9.84759 13.0223L19.2004 3.66969L12.9229 19.3633Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_16101_162212">
          <rect
            width="21"
            height="21"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Tick = () => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.898438"
        width="16.205"
        height="16.205"
        rx="1.6205"
        fill="#C4C4C4"
        fill-opacity="0.22"
      />
    </svg>
  );
};
const OffersGraphIcon = ({ matchessm }) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.66515 15.8889C4.00959 15.8889 5.10959 14.7889 5.10959 13.4444C5.10959 12.8333 4.86515 12.2222 4.49848 11.8556L6.08737 8.55556H6.33181C6.94292 8.55556 7.55404 8.31111 7.9207 7.94444L11.2207 9.65555V9.77778C11.2207 11.1222 12.3207 12.2222 13.6651 12.2222C15.0096 12.2222 16.1096 11.1222 16.1096 9.77778C16.1096 9.16667 15.8651 8.67778 15.4985 8.18889L17.0874 4.88889H17.3318C18.6763 4.88889 19.7763 3.78889 19.7763 2.44444C19.7763 1.1 18.6763 0 17.3318 0C15.9874 0 14.8874 1.1 14.8874 2.44444C14.8874 3.05556 15.1318 3.66667 15.4985 4.03333L13.9096 7.33333H13.6651C13.054 7.33333 12.4429 7.57778 12.0763 7.94444L8.77626 6.35556V6.11111C8.77626 4.76667 7.67626 3.66667 6.33181 3.66667C4.98737 3.66667 3.88737 4.76667 3.88737 6.11111C3.88737 6.72222 4.13181 7.33333 4.49848 7.7L2.90959 11H2.66515C1.3207 11 0.220703 12.1 0.220703 13.4444C0.220703 14.7889 1.3207 15.8889 2.66515 15.8889Z"
        fill="#0065FC"
      />
    </svg>
  );
};

const InfoIcon = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.5026 3.16927C7.8229 3.16927 6.21199 3.83653 5.02426 5.02426C3.83653 6.21199 3.16927 7.8229 3.16927 9.5026C3.16927 11.1823 3.83653 12.7932 5.02426 13.9809C6.21199 15.1687 7.8229 15.8359 9.5026 15.8359C11.1823 15.8359 12.7932 15.1687 13.9809 13.9809C15.1687 12.7932 15.8359 11.1823 15.8359 9.5026C15.8359 7.8229 15.1687 6.21199 13.9809 5.02426C12.7932 3.83653 11.1823 3.16927 9.5026 3.16927ZM1.58594 9.5026C1.58594 5.13023 5.13023 1.58594 9.5026 1.58594C13.875 1.58594 17.4193 5.13023 17.4193 9.5026C17.4193 13.875 13.875 17.4193 9.5026 17.4193C5.13023 17.4193 1.58594 13.875 1.58594 9.5026Z"
        fill="#2F74EE"
      />
      <path
        d="M9.5 7.91667C9.70996 7.91667 9.91133 8.00007 10.0598 8.14854C10.2083 8.29701 10.2917 8.49837 10.2917 8.70833V13.4583C10.2917 13.6683 10.2083 13.8697 10.0598 14.0181C9.91133 14.1666 9.70996 14.25 9.5 14.25C9.29004 14.25 9.08867 14.1666 8.94021 14.0181C8.79174 13.8697 8.70833 13.6683 8.70833 13.4583V8.70833C8.70833 8.49837 8.79174 8.29701 8.94021 8.14854C9.08867 8.00007 9.29004 7.91667 9.5 7.91667ZM10.6875 5.9375C10.6875 6.25244 10.5624 6.55449 10.3397 6.77719C10.117 6.99989 9.81494 7.125 9.5 7.125C9.18506 7.125 8.88301 6.99989 8.66031 6.77719C8.43761 6.55449 8.3125 6.25244 8.3125 5.9375C8.3125 5.62256 8.43761 5.32051 8.66031 5.09781C8.88301 4.87511 9.18506 4.75 9.5 4.75C9.81494 4.75 10.117 4.87511 10.3397 5.09781C10.5624 5.32051 10.6875 5.62256 10.6875 5.9375Z"
        fill="#2F74EE"
      />
    </svg>
  );
};
const ResetIcon = () => {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.59475 0.71959C6.7354 0.578986 6.92613 0.5 7.125 0.5C7.32387 0.5 7.5146 0.578986 7.65525 0.71959L9.90525 2.96959C10.0459 3.11024 10.1248 3.30097 10.1248 3.49984C10.1248 3.69871 10.0459 3.88944 9.90525 4.03009L7.65525 6.28009C7.5138 6.41671 7.32435 6.4923 7.1277 6.49059C6.93105 6.48889 6.74294 6.41001 6.60389 6.27095C6.46483 6.1319 6.38595 5.94379 6.38424 5.74714C6.38254 5.55049 6.45813 5.36104 6.59475 5.21959L7.5645 4.24984H6.375C3.714 4.24984 1.5 6.46384 1.5 9.12484C1.5 11.7858 3.714 13.9998 6.375 13.9998C9.036 13.9998 11.25 11.7858 11.25 9.12484C11.25 8.92593 11.329 8.73516 11.4697 8.59451C11.6103 8.45386 11.8011 8.37484 12 8.37484C12.1989 8.37484 12.3897 8.45386 12.5303 8.59451C12.671 8.73516 12.75 8.92593 12.75 9.12484C12.75 12.6138 9.864 15.4998 6.375 15.4998C2.886 15.4998 0 12.6138 0 9.12484C0 5.63584 2.886 2.74984 6.375 2.74984H7.5645L6.59475 1.78009C6.45415 1.63944 6.37516 1.44871 6.37516 1.24984C6.37516 1.05097 6.45415 0.860236 6.59475 0.71959Z"
        fill="#666666"
      />
    </svg>
  );
};
export const MakeOffers = ({
  isAuction,
  auctionDetails,
  makeOfferListArray,
  hideActivateTrade,
  withdrawLeftCount,
  setHideActivateTrade,
  setShowActivateTrade,
  lastHighestOffers,
  setLastHighestOffers,
  stage,
  groupIt,
  groupCall,
  getlistMakeOffer,
  getBuyerIndividualValue,
  confirmAcceptLog,
  setOpenlogin,
  openlogin,
  sharedpage,
  doc66wstatus,
  st1condition,
  st2condition,
  setDontallowtooffer,
  array,
  hideOthers,
  SetHideOthers,
  offerHistoryState,
  tabData,
  setTabDAta,
  setNewTabData,
  isFocusMode,
  setShowPropertyTimer,
  offersOnly,
  setOpenFocusDialog,
  isStageTwoRequested,
  setIsStageTwoRequested,
  checkListArray,
  uploadDoc,
  directcomm,
  handleCloseFocus,
  focusModeActionTabSwitching,
  realTimeLog,
  setOffersOnly,
  isConditionalChanceCompleted,
  lastLatestOffer,
  setTypeofsolicitorpopup,
  setOpensolicitorpopup,
}) => {
  const agentBuyerBinderId =
    getBuyerIndividualValue?.PropertyDetails?.agentBuyerBinderId;
  const audiofile =
    JSON.parse(localStorage.getItem('audiofiles') || '{}')?.OfferedSubmitted ??
    '';
  const [audioplay] = useSound(audiofile);
  const [settlementDays, setSettlementDays] = useState(null);
  const [depositAmount, setDepositAmount] = useState(null);
  const [conditional, setConditional] = useState(false);
  const [conditionalNotAvailable, setConditionalNotAvailable] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [maximumOffer, setMaximumOffer] = useState('');
  const [offerIncreamnet, setOfferIncreament] = useState('');
  const [isAutoOffer, setIsAutoOffer] = useState(false);
  const [continueTheseOffer, setContinueTheseOffer] = useState(false);
  const [acceptterms, setAcceptterms] = useState(false);
  const [isConditionalCode, setIsConditionalCode] = useState({});
  const [isBestOffer, setIsBestOffer] = useState(false);
  const [addictionComment, setAdditionalComment] = useState('');
  const [offerExpiry, setOfferExpiry] = useState('');
  const [offerExp, setOfferExp] = useState(null);
  const [stateIndex, setStateIndex] = useState(-1);
  const [open, setOpen] = React.useState(false);
  const [openBox, setOpenBox] = useState(false);
  const [showTick, setShowTick] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoader, setIsLoader] = useState(false);
  const [identicalsuggestion, setIdenticalsuggestion] = useState(false);
  const [makeOfferresponse, setMakeOfferresponse] = useState('');
  const [openCancel, setOpenCancel] = useState(false);
  const [confirmCancel, setConfirmCancel] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [iconDis, setIconDis] = useState(false);
  const s1minIncrement = array?.stageOneCondition?.MinimumIncrement;
  const s2minIncrement = array?.stageTwoCondition?.MinimumIncrement;
  const IsLastChance = array?.isLastChance;
  const increment = stage == 'ST1' ? s1minIncrement : s2minIncrement;
  const lastOfferAmount = array?.lastOffer;
  const [continueLog, setContinueLog] = useState();
  const [isFocusedofferexpiry, setIsFocusedofferexpiry] = useState(false);
  const [showResentOffer, setShowResentOffer] = useState(false);
  const [isEditActionClicked, setIsEditActionClicked] = useState(false);
  const [isDeleteActionClicked, setIsDeleteActionClicked] = useState(false);

  const maximumOfferValue = Number(
    getBuyerIndividualValue?.PropertyDetails?.getBuyerLatestOfferDetails
      ?.offermaximumOfferOne
  );
  useEffect(() => {
    setContinueLog(totalAmount >= maximumOfferValue);
  }, [totalAmount, maximumOfferValue]);

  const minimumValidOffer =
    IsLastChance == 1
      ? parseFloat(lastOfferAmount)
      : parseFloat(lastOfferAmount) + parseFloat(increment);
  const [placeholder, setPlaceholder] = useState('0');
  const [offerExpiryValue, setOfferExpiryValue] = useState(null);

  useEffect(() => {
    if (totalAmount == 0) {
      setPlaceholder('0');
    }
  }, [totalAmount]);

  const formatTime = (time) => {
    return time.toLocaleTimeString('en-AU', {
      timeZone: 'Australia/Sydney',
      hour12: false,
    });
  };
  const params = useParams();
  let propertyId = params?.propertyId;

  const { setIsBinderChatOpen } = useContext(PropertyContext);

  const [continueAutOffer, setContinueAutOffer] = useState(false);
  const [summaryView, setSummaryView] = useState(false);
  const [isFocusModeConditional, setIsFocusModeConditional] = useState(false);

  const [focusModeTermsDialogOpen, setFocusModeTermsDialogOpen] =
    useState(false);

  const [settleDays, setSettleDays] = useState();
  const [depAmount, setDepAmount] = useState();

  const handleOpenFocusModeTerms = () => {
    setFocusModeTermsDialogOpen(true);
  };

  const fabSummaryClose = () => {
    setMaximumOffer('');
    setOfferIncreament('');
    setSummaryView(true);
    setIsAutoOffer(false);
    setShowSuccess(false);
    setEnableAction(true);
  };

  const handlecloseFocusModeTerms = () => {
    setIsFocusModeConditional(false);
    setFocusModeTermsDialogOpen(false);
  };

  const [autoOfferCancelled, setAutoOfferCancelled] = useState(false);

  useEffect(() => {
    const propertyDetails = getBuyerIndividualValue?.PropertyDetails;
    const latestOffer = propertyDetails?.getBuyerLatestOfferDetails;

    const highestOfferValue = Number(
      (propertyDetails?.highestOffer || '0').replace(/[$,]/g, '')
    );

    const autoOfferValue = Number(latestOffer?.offermaximumOfferOne || 0);

    const isAutoOffer = latestOffer?.isAutoOffer === 1;

    setAutoOfferCancelled(isAutoOffer && highestOfferValue >= autoOfferValue);
  }, [getBuyerIndividualValue, realTimeLog]);

  const [graphAction, setGraphAction] = useState(false);

  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    type: 'line',
    datasets: [
      {
        label: 'First dataset',
        data: [33, 53, 85, 41, 44, 65],
        fill: true,
        backgroundColor: '#B09FFF26',
        borderColor: '#6C2AD2',
      },
      {
        label: 'Second dataset',
        data: [33, 25, 35, 51, 54, 76],
        fill: false,
        borderColor: '#742774',
      },
    ],
  };

  const isRequestAccessLock =
    (getBuyerIndividualValue?.PropertyDetails?.stage == 'ST2' &&
    getBuyerIndividualValue?.PropertyDetails?.isStageTwo == '0'
      ? true
      : false) &&
    getBuyerIndividualValue?.PropertyDetails?.timerStatus != 'Pause' &&
    getBuyerIndividualValue?.PropertyDetails?.campaignType != 'Auction' &&
    getBuyerIndividualValue?.PropertyDetails?.isWinner != '1' &&
    !sharedpage;

  useEffect(() => {
    const offerDetails =
      getBuyerIndividualValue?.PropertyDetails?.getBuyerLatestOfferDetails;

    if (offerDetails?.isAutoOffer === 1 && !isEditActionClicked) {
      setSummaryView(true);
      setOfferIncreament(
        formatNumberWithCommas(offerDetails.offerIncrementOne)
      );
      setMaximumOffer(
        formatNumberWithCommas(offerDetails.offermaximumOfferOne)
      );
    } else {
      setSummaryView(false);
      setIsEditActionClicked(false);
    }
  }, [getBuyerIndividualValue, continueTheseOffer]);

  const isContractCompleted = checkListArray?.some(
    (task) => task.taskCode === 'RevCon001' && task.taskStatus === 'Completed'
  );

  const is66wCompleted = checkListArray?.some(
    (task) => task.taskCode === '66W001' && task.taskStatus === 'Completed'
  );

  const viewContractCompleted = checkListArray?.some(
    (task) => task.taskCode === 'Con001' && task.taskStatus === 'Reviewed'
  );

  const [loading, setLoading] = useState(false);

  const RequestStageTwo = () => {
    const data = {
      propertyId: propertyId,
    };
    setIsStageTwoRequested(1);
    setLoading(true);
    postApiCall(BUYER_REQUESTSTAGE2, data)
      .then((res) => {
        if (res?.data?.status == 1) {
          groupCall();
          setLoading(false);
        }
      })
      .catch(() => setLoading(false));
  };

  const cancelOffer = () => {
    if (
      getBuyerIndividualValue?.PropertyDetails?.getBuyerLatestOfferDetails
        ?.isAutoOffer == 1
    ) {
      setSummaryView(true);
    }
    setConfirmCancel(false);
    setOpenCancel(true);
    const data = {
      propertyId,
      offerPrice: totalAmount,
    };
    postApiCall(BUYER_OFFERCANCEL, data)
      .then(() => {})
      .catch(() => {});
  };

  const propertyDetails = getBuyerIndividualValue?.PropertyDetails;

  const isEnded = propertyDetails?.timerStatus === 'End';
  const isPause = propertyDetails?.timerStatus === 'Pause';

  const showOverlayEnded = isEnded && propertyDetails?.isStageTwo == 0;

  const showFullEnded =
    !showOverlayEnded && !graphAction && isEnded && !isRequestAccessLock;

  const data1 = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data1);
  const buyerId = Number(userDetail?.userId);

  let buyerOffers = showResentOffer ? lastLatestOffer : lastHighestOffers;

  const latestOfferPrice = buyerOffers?.find(
    (item) => item?.buyerUniqueId === userDetail?.userAppId
  )?.originalOfferPrice;

  const [enableAction, setEnableAction] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const [deleteOfferLoading, setDeleteOfferLoading] = useState(false);
  const [openDeleteAutoOffer, setOpenDeleteAutoOffer] = useState(false);

  const [saveLoading, setSaveLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  const [formattedTotalAmounts, setFormattedTotalAmount] = useState('');
  const EditAutoOfferSummary = () => {
    const data = {
      propertyId:
        getBuyerIndividualValue?.PropertyDetails?.property?.propertyId,
      buyerId: buyerId,
      isAutoOffer: 1,
      maximumOffer: maximumOffer
        ? parseInt(maximumOffer?.replace(/,/g, ''), 10)
        : 0, // Convert to number,
      offerIncrement: offerIncreamnet
        ? parseInt(offerIncreamnet?.replace(/,/g, ''), 10)
        : 0, // Convert to number,
    };
    setSaveLoading(true);
    postApiCall(EDIT_AUTO_OFFER, data)
      .then((res) => {
        if (res?.data?.status == 1) {
          groupCall();
          groupIt();
          Swal.fire({
            title: res?.data?.heading ?? '-',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          });
          setSaveLoading(false);
          setSuccess(true);
        } else {
          Swal.fire({
            title: 'Error',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          });
          setSaveLoading(false);
        }
      })
      .catch(() => setSaveLoading(false));
  };

  const DeleteAutoOfferSummary = async (fromAutoOfferSubmit) => {
    setIsDeleteActionClicked(true);
    const data = {
      propertyId:
        getBuyerIndividualValue?.PropertyDetails?.property?.propertyId,
      buyerId: buyerId,
    };
    setDeleteOfferLoading(true);
    setMaximumOffer('');
    setOfferIncreament('');
    try {
      const res = await postApiCall(DELETE_AUTO_OFFER, data);
      setDeleteOfferLoading(false);
      setOpenDeleteAutoOffer(false);

      if (res?.data?.status === 1) {
        if (!fromAutoOfferSubmit) {
          groupIt();
          groupCall();
        }
        if (!fromAutoOfferSubmit) {
          Swal.fire({
            title: res?.data?.heading ?? '-',
            text: res?.data?.message ?? '-',
            icon: 'success',
            confirmButtonText: 'Close',
          });
        }
      } else {
        if (!fromAutoOfferSubmit) {
          Swal.fire({
            title: 'Error',
            text: res?.data?.message,
            icon: 'error',
            confirmButtonText: 'Close',
          });
        }
      }
    } catch {
      setDeleteOfferLoading(false);
      setOpenDeleteAutoOffer(false);
    } finally {
      setIsAutoOffer(false);
      if (!fromAutoOfferSubmit) {
        setIsDeleteActionClicked(false);
      }
    }
  };

  useEffect(() => {
    if (deleteOfferLoading || saveLoading || loading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [deleteOfferLoading, saveLoading, loading]);

  const buttonSx = {
    ...(success && {
      bgcolor: green[500],
      '&:hover': {
        bgcolor: green[700],
      },
    }),
  };

  const currentMax = parseFloat(maximumOffer?.replace(/,/g, ''));
  const currentInc = parseFloat(offerIncreamnet?.replace(/,/g, ''));

  const autoOfferValue =
    getBuyerIndividualValue?.PropertyDetails?.getBuyerLatestOfferDetails;

  const maxChanged =
    currentMax > parseFloat(autoOfferValue?.offermaximumOfferOne || 0);
  const incChanged =
    currentInc === parseFloat(Number(autoOfferValue?.offerIncrementOne) || 0);

  const history = useHistory();

  const offerSummaryText = {
    ...poppins400,
    color: '#666666',
    fontSize: '16px',
  };
  const offerSummaryValue = {
    ...poppins400,
    color: '#000000',
    fontSize: '16px',
  };

  const formatDate = (time) => {
    return time.toLocaleDateString('en-AU', {
      timeZone: 'Australia/Sydney',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  useEffect(() => {
    if (isLoading || isLoader) {
      setCurrentTime(new Date());
    }
  }, [isLoading, isLoader]);

  const maximumOfferIncrease = () => {
    let numericValue = parseInt(maximumOffer?.replace(/,/g, ''), 10);
    if (isNaN(numericValue) || numericValue === 0) {
      setMaximumOffer(increment.toLocaleString('en-US'));
    } else if (numericValue < 999999999) {
      setMaximumOffer((numericValue + increment).toLocaleString('en-US'));
    }
  };

  const maximumOfferDecrease = () => {
    let numericValue = parseInt(maximumOffer?.replace(/,/g, ''), 10);
    if (!isNaN(numericValue) && numericValue >= increment) {
      setMaximumOffer((numericValue - increment).toLocaleString('en-US'));
    } else {
      setMaximumOffer('0');
    }
  };

  // ---------------Offer Increment

  const formattedTotalAmount = totalAmount.toLocaleString('en-US', {});
  const [emptyIncreamnetValidation, setEmptyIncreamnetValidation] =
    useState(false);

  const [offerIncreamnetValidation, setOfferIncreamnetValidation] =
    useState(false);
  const [maximumOfferValidation, setMaximumOfferValidation] = useState(false);
  const [maximumOfferValidationTwo, setMaximumOfferValidationTwo] =
    useState(false);
  const [offerIncreamnetError, setOfferIncreamnetError] = useState(false);

  const offerValue =
    typeof formattedTotalAmount === 'string'
      ? parseInt(formattedTotalAmount.replace(/[^0-9]/g, ''), 10) || 0
      : formattedTotalAmount || 0;

  const showMeterChart = buyerOffers?.length > 0 || Number(offerValue) > 0;

  const valueone =
    typeof maximumOffer === 'string'
      ? parseInt(maximumOffer.replace(/[^0-9]/g, ''), 10) || 0
      : maximumOffer || 0;

  const valuetwo =
    typeof offerIncreamnet === 'string'
      ? parseInt(offerIncreamnet.replace(/[^0-9]/g, ''), 10) || 0
      : parseInt(offerIncreamnet, 10) || 0;

  const yourLastOfferAmount =
    getBuyerIndividualValue?.PropertyDetails?.yourOffer;
  const maxAllowedOffer = offerValue + valuetwo;
  const maximumOfferAdditionalCondition = maxAllowedOffer > valueone; // Maximum Offer = Offer amount + Offer Increment

  const summaryMaximumValue =
    getBuyerIndividualValue?.PropertyDetails?.getBuyerLatestOfferDetails
      ?.offermaximumOffer;
  const cleanedValue = summaryMaximumValue?.replace(/[$,]/g, '');
  const editAutoOfferMaximumValue = Number(cleanedValue) >= Number(valueone);

  const isMaximumOffer_MinOfferIncrement =
    maximumOfferAdditionalCondition && offerIncreamnet && maximumOffer !== 0;

  useEffect(() => {
    const isValueOneValid = valueone !== 0 && valueone !== '';
    const isOfferExceeded =
      isValueOneValid && valueone < offerValue && isAutoOffer;
    const isLastOfferHigher =
      showSuccess && isAutoOffer && yourLastOfferAmount > valueone;
    const hasAdditionalCondition =
      maximumOfferAdditionalCondition && offerIncreamnet && maximumOffer !== 0;
    const isMissingIncrement = maximumOffer && !offerIncreamnet;
    const isIncrementInvalid = valuetwo < increment && valuetwo !== 0;
    const isIncrementTooHigh = valuetwo > valueone;
    const isMaximumOfferMinIncrement = increment + offerValue;

    if (isOfferExceeded || isLastOfferHigher) {
      setMaximumOfferValidation(true);
      setMaximumOfferValidationTwo(false);
      setEmptyIncreamnetValidation(false);
      setOfferIncreamnetValidation(false);
      setOfferIncreamnetError(false);
    } else if (
      isAutoOffer &&
      isValueOneValid &&
      isMaximumOfferMinIncrement > valueone
    ) {
      setMaximumOfferValidationTwo(true);
      setMaximumOfferValidation(false);
      setEmptyIncreamnetValidation(false);
      setOfferIncreamnetValidation(false);
      setOfferIncreamnetError(false);
    } else if (isValueOneValid && hasAdditionalCondition) {
      setMaximumOfferValidation(false);
      setMaximumOfferValidationTwo(true);
      setEmptyIncreamnetValidation(false);
      setOfferIncreamnetValidation(false);
      setOfferIncreamnetError(false);
    } else if (isMissingIncrement) {
      setEmptyIncreamnetValidation(true);
      setMaximumOfferValidation(false);
      setMaximumOfferValidationTwo(false);
      setOfferIncreamnetValidation(false);
      setOfferIncreamnetError(false);
    } else if (isIncrementTooHigh) {
      setOfferIncreamnetValidation(true);
      setMaximumOfferValidation(false);
      setMaximumOfferValidationTwo(false);
      setOfferIncreamnetError(false);
      setEmptyIncreamnetValidation(false);
    } else if (isIncrementInvalid) {
      setOfferIncreamnetError(true);
      setOfferIncreamnetValidation(false);
      setMaximumOfferValidation(false);
      setMaximumOfferValidationTwo(false);
      setEmptyIncreamnetValidation(false);
    } else {
      setMaximumOfferValidation(false);
      setMaximumOfferValidationTwo(false);
      setEmptyIncreamnetValidation(false);
      setOfferIncreamnetValidation(false);
      setOfferIncreamnetError(false);
    }
  }, [maximumOffer, offerIncreamnet, offerValue, valueone, valuetwo]);

  const maximumOfferhandleChange = (e) => {
    const input = e.target;
    const rawValue = input.value;
    const selectionStart = input.selectionStart;

    // Remove all non-digits
    let unformatted = rawValue.replace(/[^0-9]/g, '');
    if (unformatted.length > 9) return;

    // Limit to 9 digits
    if (unformatted.length > 9) {
      unformatted = unformatted.slice(0, 9);
    }

    if (unformatted === '0') {
      setMaximumOffer('');
      setMaximumOfferValidation(false);
      setEnableAction(false);
      return;
    }

    const formattedValue = unformatted.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    setMaximumOffer(formattedValue);
    setEnableAction(true);

    // Cursor fix after formatting
    setTimeout(() => {
      const digitCountBeforeCursor = rawValue
        .slice(0, selectionStart)
        .replace(/[^0-9]/g, '').length;

      let newCursorPosition = 0;
      let digitSeen = 0;

      for (let i = 0; i < formattedValue.length; i++) {
        if (/\d/.test(formattedValue[i])) {
          digitSeen++;
        }
        if (digitSeen === digitCountBeforeCursor) {
          newCursorPosition = i + 1;
          break;
        }
      }

      input.setSelectionRange(newCursorPosition, newCursorPosition);
    }, 0);
  };

  const formatNumberWithCommas = (value) => {
    if (!value) return '';
    // Remove non-numeric characters except for commas
    const numericValue = value.toString().replace(/[^0-9]/g, '');
    return Number(numericValue).toLocaleString('en-US');
  };

  const OfferhandleChange = (e) => {
    const input = e.target;
    const rawValue = input.value;
    const selectionStart = input.selectionStart;

    let value = rawValue.replace(/[^0-9]/g, '');
    if (value.length > 9) return;

    if (value.length > 6) value = value.slice(0, 9);

    if (value === '0') {
      setOfferIncreament('');
      setEnableAction(false);
      setOfferIncreamnetValidation(false);
    } else {
      const formattedValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      setOfferIncreament(formattedValue);
      setEnableAction(true);

      // Restore cursor position after formatting
      setTimeout(() => {
        const digitsBeforeCursor = rawValue
          .slice(0, selectionStart)
          .replace(/[^0-9]/g, '').length;

        let newCursorPos = 0;
        let digitCount = 0;

        for (let i = 0; i < formattedValue.length; i++) {
          if (/\d/.test(formattedValue[i])) {
            digitCount++;
          }
          if (digitCount === digitsBeforeCursor) {
            newCursorPos = i + 1;
            break;
          }
        }

        input.setSelectionRange(newCursorPos, newCursorPos);
      }, 0);
    }
  };

  const OfferIncrease = () => {
    let numericValue = parseInt(offerIncreamnet?.replace(/,/g, ''), 10);
    if (isNaN(numericValue) || numericValue === 0) {
      setOfferIncreament(increment.toLocaleString('en-US'));
    } else if (numericValue < 999999999) {
      setOfferIncreament((numericValue + increment).toLocaleString('en-US'));
    }
  };

  const OfferDecrease = () => {
    let numericValue = parseInt(offerIncreamnet?.replace(/,/g, ''), 10);
    if (!isNaN(numericValue) && numericValue >= increment) {
      setOfferIncreament((numericValue - increment).toLocaleString('en-US'));
    } else {
      setOfferIncreament('0');
    }
  };

  const [openCard, setOpenCard] = useState(false);
  const [selectedConditionCodes, setSelectedConditionCodes] = useState([]);
  const [subtoAddSelected, setSubtoAddSelected] = useState(false);

  const isConditionCodesValidation =
    selectedConditionCodes.length > 0 || addictionComment.trim().length > 0;

  const [resetTerms, setResetTerms] = useState(false);
  const [saveTerms, setSaveTerms] = useState(false);

  const targetRef = useRef(null);

  const isUnconditional =
    stage === 'ST1'
      ? st1condition?.UnconditionalOnly === 1
      : st2condition?.UnconditionalOnly === 1;

  const isConditionalActive =
    conditional &&
    !(
      (doc66wstatus === 0 || (doc66wstatus === 1 && conditional)) &&
      isUnconditional
    );

  const [error, setError] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSubtoAddSelected(false);
    setSelectedConditionCodes((prev) =>
      prev.filter((code) => code != 'SubtoAdd001')
    );
    setAdditionalComment('');
    setError(false);
  };

  const handleSubmit = () => {
    if (!addictionComment.trim()) {
      setError(true);
      return;
    }
    setError(false);
    setSubtoAddSelected(true);
    setSelectedConditionCodes((prev) => {
      if (!prev.includes('SubtoAdd001')) {
        return [...prev, 'SubtoAdd001'];
      }
      return prev;
    });
    setOpen(false);
  };

  const validationfun = async () => {
    if (totalAmount == '0') {
      Swal.fire({
        title: 'Offer Error',
        text: 'Please enter a valid offer amount',
        showDenyButton: false,
        showCancelButton: false,
        icon: 'error',
        confirmButtonText: 'Close',
      });
      return;
    } else if (!isConditionCodesValidation && isConditionalActive) {
      Swal.fire({
        title: 'Select Terms',
        text: 'Please select conditional terms',
        showDenyButton: false,
        showCancelButton: false,
        icon: 'error',
        confirmButtonText: 'Close',
      });
      return;
    } else if (parseFloat(totalAmount) < parseFloat(minimumValidOffer)) {
      const result = await Swal.fire({
        title: 'Offer Error',
        html: `The offer you made is below the minimum increment <strong>$${formatNumberWithCommas(
          increment
        )}</strong>.`,
        showDenyButton: false,
        showCancelButton: false,
        icon: 'error',
        confirmButtonText: 'Close',
      });
    } else if (isAutoOffer && maximumOffer == 0) {
      Swal.fire({
        title: 'Error',
        text: 'Please enter a valid maximum amount',
        showDenyButton: false,
        showCancelButton: false,
        icon: 'error',
        confirmButtonText: 'Close',
      });
      return;
    } else if (isAutoOffer && offerIncreamnet == 0) {
      Swal.fire({
        title: 'Error',
        text: 'Please enter a valid offer increament amount',
        showDenyButton: false,
        showCancelButton: false,
        icon: 'error',
        confirmButtonText: 'Close',
      });
      return;
    } else if (isConditionalCode === '') {
      Swal.fire({
        title: 'Error',
        text: 'Please select a valid condition',
        showDenyButton: false,
        showCancelButton: false,
        icon: 'error',
        confirmButtonText: 'Close',
      });
      return;
    } else {
      if (stage === 'ST1') {
        setCurrentTime(new Date());
        setOpenCard(!openCard);
      } else {
        if (confirmAcceptLog === 1) {
          setCurrentTime(new Date());
          setOpenCard(!openCard);
        } else {
          setCurrentTime(new Date());
          setOpenBox(!openBox);
        }
      }
    }
  };

  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const moxoapis = async (res) => {
    if (isNotEmptyArray(res?.dataForABPropertyBinder))
      await Moxoseparationinlisting(
        'dataForBuyerAgentBinder',
        res?.dataForABPropertyBinder
      ); //1
    if (isNotEmptyArray(res?.dataForABBinder))
      await Moxoseparationinlisting(
        'dataForBuyerAgentBinder',
        res?.dataForABBinder
      ); //2
    if (isNotEmptyArray(res?.dataForAgentAck))
      Moxoseparationinlisting('dataForAgentAck', res?.dataForAgentAck); //3
    if (isNotEmptyArray(res?.dataForBuyerAck))
      Moxoseparationinlisting('dataForBuyerOfferAck', res?.dataForBuyerAck); //4
    if (isNotEmptyArray(res?.dataForVendorAck))
      Moxoseparationinlisting('dataForVendorAck', res?.dataForVendorAck); //5
  };

  const latestAutoOffer =
    getBuyerIndividualValue?.PropertyDetails?.getBuyerLatestOfferDetails
      ?.isAutoOffer === 1;

  const autoOfferInputValue = isDeleteActionClicked
    ? 0
    : isAutoOffer || latestAutoOffer
    ? 1
    : 0;

  const makeOffer = (lowest, isIdenticalAccepted) => {
    if (!lowest) {
      setIsLoading(false);
      setIsLoader(true);
    }
    let input = {
      propertyId: propertyId,
      offerPrice: totalAmount,
      validUpto: offerExpiry,
      isFinal: isBestOffer ? 1 : 0,
      isConditional: conditional ? 1 : 0,
      isAutoOffer: autoOfferInputValue,
      maximumOffer: maximumOffer
        ? parseInt(maximumOffer?.replace(/,/g, ''), 10)
        : null,
      offerIncrement: offerIncreamnet
        ? parseInt(offerIncreamnet.replace(/,/g, ''), 10)
        : null,
      conditionCode: selectedConditionCodes,
      additionalCondition: addictionComment,
      isLowest: lowest ? 1 : 0,
      isIdenticalAccepted: isIdenticalAccepted ? isIdenticalAccepted : 0,
      depositAmount: depAmount,
      settleDays: settleDays,
    };
    makeOfferRequest(input)
      .then((res) => {
        if (res?.status == '1') {
          setMakeOfferresponse(res);
          setSelectedConditionCodes([]);
          if (res?.isConditionalChanceCompleted == '1') {
            setOpenCampaignRestrictedPopup(true);
            setIsLoader(false);
            setShowTick(true);
          } else if (res?.isIdentical == '1') {
            setIdenticalsuggestion(true);
          } else {
            groupIt();
            groupCall();
            setIsLoader(false);
            setShowTick(true);
            audioplay();
            moxoapis(res);
          }
        } else {
          Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: true,
            icon: 'error',
            confirmButtonText: 'Continue',
          }).then((result) => {
            if (result.isConfirmed) {
              makeOffer('lowest');
            } else if (result.isDismissed) {
              setIsLoader(false);
              setOpenCancel(true);
            }
          });
        }
      })
      .catch(() => {
        setIsLoader(false);
        setOpenCancel(!openCancel);
      })
      .finally((res) => {
        setIsDeleteActionClicked(false);
        if (res?.isIdentical == '0') {
          if (
            getBuyerIndividualValue?.PropertyDetails?.getBuyerLatestOfferDetails
              ?.isAutoOffer == 1
          ) {
            setSummaryView(true);
          } else if (
            getBuyerIndividualValue?.PropertyDetails?.getBuyerLatestOfferDetails
              ?.isAutoOffer == 0
          ) {
            setSummaryView(false);
          }
          setOfferIncreament(
            formatNumberWithCommas(
              getBuyerIndividualValue?.PropertyDetails
                ?.getBuyerLatestOfferDetails?.offerIncrementOne
            )
          );
          setMaximumOffer(
            formatNumberWithCommas(
              getBuyerIndividualValue?.PropertyDetails
                ?.getBuyerLatestOfferDetails?.offermaximumOfferOne
            )
          );
        }
      });
  };

  const isOfferAllowed =
    (conditional &&
      !maximumOfferValidation &&
      !offerIncreamnetValidation &&
      !offerIncreamnetError &&
      !emptyIncreamnetValidation &&
      (stage == 'ST1'
        ? st1condition?.UnconditionalOnly == 0
        : st2condition?.UnconditionalOnly == 0)) ||
    (!conditional && doc66wstatus == 1);

  const submitOfferHandler = () => {
    if (getBuyerIndividualValue?.PropertyDetails?.timerStatus === 'End') return;

    if (totalAmount == '0') {
      handleMakeOffer();
    } else if (parseFloat(totalAmount) < parseFloat(minimumValidOffer)) {
      handleMakeOffer();
    } else if (summaryView && totalAmount) {
      setContinueTheseOffer(true);
    } else {
      handleMakeOffer();
    }
  };

  const handleMakeOffer = () => {
    if (isAutoOffer && !maximumOffer && offerIncreamnet) {
      return;
    } else if (offerIncreamnetValidation == true) {
      return;
    } else if (maximumOffer && !offerIncreamnet) {
      return;
    } else if (isAutoOffer && maximumOfferValidation == true) {
      return;
    } else if (isAutoOffer && maximumOfferValidationTwo == true) {
      return;
    }

    setIconDis(false);
    if (sharedpage) {
      setOpenlogin(!openlogin);
    } else {
      if (
        IsLastChance == 1 ||
        (['Offer Updated', 'Offer Submitted', 'Pending'].includes(
          getBuyerIndividualValue?.PropertyDetails?.offerStatus?.status
        ) &&
          getBuyerIndividualValue?.PropertyDetails?.stage == 'ST1')
      ) {
        if (
          IsLastChance != 1 &&
          parseFloat(totalAmount) <= parseFloat(lastOfferAmount) &&
          totalAmount != '0'
        ) {
          setDontallowtooffer(true);
          setTotalAmount(0);
          setOfferExp(null);
          setIsBestOffer(false);
          setIsAutoOffer(false);
          setMaximumOffer('');
          setOfferIncreament('');
        } else {
          validationfun();
        }
      } else {
        if (
          conditional &&
          (stage == 'ST1'
            ? st1condition?.UnconditionalOnly == 0
            : st2condition?.UnconditionalOnly == 0)
        ) {
          validationfun();
          if (stage != 'ST1') {
            setIsLoading(true);
            setIsLoader(false);
          }
        } else if (!conditional && doc66wstatus == 1) {
          validationfun();
          if (stage != 'ST1') {
            setIsLoading(true);
            setIsLoader(false);
          }
        } else {
        }
      }
    }
  };

  const handleCancelAutoOffer = async () => {
    await DeleteAutoOfferSummary(true);
    setShowSuccess(false);
    setEnableAction(false);
    setContinueTheseOffer(false);
    setMaximumOffer('');
    setOfferIncreament('');
    handleMakeOffer();
  };

  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches400 = useMediaQuery(theme.breakpoints.down(400));
  const matches1100 = useMediaQuery(theme.breakpoints.down(1100));
  const matches1280 = useMediaQuery(theme.breakpoints.down(1280));
  const matches1440 = useMediaQuery(theme.breakpoints.down(1440));
  const [isInteracted, setIsInteracted] = useState(false);
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const isSmallHeight = useMediaQuery('(max-height:700px)');
  const [openCampaignRestrictedPopup, setOpenCampaignRestrictedPopup] =
    useState(false);
  const isMac =
    typeof navigator !== 'undefined' && navigator.userAgent.includes('Mac');
  useEffect(() => {
    if (matchessm) {
      setConditional(null);
    } else {
      setConditional(
        isConditionalChanceCompleted == 1
          ? false
          : doc66wstatus != 0
          ? false
          : stage == 'ST2'
          ? false
          : true
      );
    }
  }, [doc66wstatus, stage, matchessm, isConditionalChanceCompleted]);
  const nextConditional = false;

  const [remainingTime, setRemainingTime] = useState(0);

  useEffect(() => {
    if (
      getBuyerIndividualValue?.PropertyDetails?.timerStatus != 'Pause' ||
      !getBuyerIndividualValue?.PropertyDetails?.resumedAt
    ) {
      return;
    }

    const resumeTime = dayjs.tz(
      getBuyerIndividualValue.PropertyDetails.resumedAt,
      'Australia/Sydney'
    );

    const interval = setInterval(() => {
      const now = dayjs().tz('Australia/Sydney');
      const diff = resumeTime.diff(now);
      setRemainingTime(diff > 0 ? diff : 0);

      if (diff <= 0) clearInterval(interval);
    }, 1000);

    return () => clearInterval(interval);
  }, [
    getBuyerIndividualValue?.PropertyDetails?.timerStatus,
    getBuyerIndividualValue?.PropertyDetails?.resumedAt,
  ]);

  const getTimeUnits = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    return {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    };
  };

  return (
    <>
      <Card
        sx={{
          width: '100%',
          height: isFocusMode ? '700px' : 'auto',
          backgroundColor: '#FFFFFF',
          border: !matchessm && '0.5px solid #E4E4E4',
          boxShadow: 'none',
          marginBottom: '30px',
          padding: matchessm ? '10px' : '20px',
          background: isFocusMode && '#FAFAFA',
        }}
      >
        {
          <Stack>
            <Stack sx={{ width: isFocusMode ? '97%' : '100%' }}>
              <Grid
                sx={{
                  display: 'flex',
                  flexDirection: matches1100 ? 'column' : 'row',
                  width: '100%',
                  justifyContent: 'space-between',
                  gap: matchessm ? '20px' : '30px',
                  background: isFocusMode && '#FAFAFA',
                }}
              >
                <OffersSection
                  lastHighestOffers={lastHighestOffers}
                  setLastHighestOffers={setLastHighestOffers}
                  tabData={tabData}
                  offerHistoryState={offerHistoryState}
                  sharedpage={sharedpage}
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  getlistMakeOffer={getlistMakeOffer}
                  withdrawLeftCount={withdrawLeftCount}
                  stage={stage}
                  openlogin={openlogin}
                  groupCall={groupCall}
                  groupIt={groupIt}
                  setOpenlogin={setOpenlogin}
                  isFocusMode={isFocusMode}
                  offersOnly={offersOnly}
                  setOffersOnly={setOffersOnly}
                  setGraphAction={setGraphAction}
                  graphAction={graphAction}
                  setTotalAmount={setTotalAmount}
                  setMaximumOffer={setMaximumOffer}
                  setOfferIncreament={setOfferIncreament}
                  isConditionalChanceCompleted={isConditionalChanceCompleted}
                  lastLatestOffer={lastLatestOffer}
                  showResentOffer={showResentOffer}
                  setShowResentOffer={setShowResentOffer}
                />
                {graphAction ? (
                  <Grid
                    container
                    spacing={3}
                    sx={{
                      alignItems: 'stretch',
                      width: matches1100 ? '100%' : '50%',
                    }}
                  >
                    {/* -------- First Chart -------- */}
                    <Grid item xs={12}>
                      <Box px={4} pb={4}>
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          mb={2}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'Poppins',
                              fontWeight: 500,
                              fontSize: 24,
                              color: '#000',
                              backgroundColor: isFocusMode
                                ? '#FAFAFA'
                                : 'transparent',
                            }}
                          >
                            Offer Trajectory
                          </Typography>

                          <IconButton
                            onClick={() => setGraphAction(false)}
                            sx={{
                              height: 42,
                              width: 42,
                              border: '1px solid #E0E0E0',
                              borderRadius: '8px',
                              '&:hover': {
                                backgroundColor: '#F7F3FF',
                                borderColor: '#6C2AD2',
                              },
                            }}
                          >
                            <OffersGraphIcon />
                          </IconButton>
                        </Stack>
                        <Grid item xs={12}>
                          <Box sx={{ width: '100%', height: 200 }}>
                            <Line
                              data={data}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                              }}
                            />
                          </Box>
                        </Grid>
                      </Box>
                    </Grid>

                    {/* -------- Second Chart -------- */}
                    <Grid item xs={12}>
                      <Box px={4} pb={4}>
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          mb={2}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'Poppins',
                              fontWeight: 500,
                              fontSize: 24,
                              color: '#000',
                              backgroundColor: isFocusMode
                                ? '#FAFAFA'
                                : 'transparent',
                            }}
                          >
                            Offer Trajectory
                          </Typography>
                        </Stack>

                        <Grid item xs={12}>
                          <Box sx={{ width: '100%', height: 200 }}>
                            <Line
                              data={data}
                              options={{
                                responsive: true,
                                maintainAspectRatio: false,
                              }}
                            />
                          </Box>
                        </Grid>
                      </Box>
                    </Grid>
                  </Grid>
                ) : (
                  (getBuyerIndividualValue?.PropertyDetails?.stage == 'ST2' &&
                  getBuyerIndividualValue?.PropertyDetails?.isStageTwo == '0'
                    ? false
                    : true) &&
                  getBuyerIndividualValue?.PropertyDetails?.timerStatus !==
                    'End' &&
                  getBuyerIndividualValue?.PropertyDetails?.timerStatus !==
                    'Pause' &&
                  !hideOthers &&
                  !sharedpage && (
                    <Stack
                      sx={{
                        display: 'flex',
                        width: matches1100 ? '100%' : '50%',
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '500 !important',
                          fontSize: '24px',
                          color: '#000000',
                          background: isFocusMode && '#FAFAFA',
                        }}
                      >
                        <MakeOfferLabel ref={targetRef}>
                          Make Your Offer
                        </MakeOfferLabel>
                      </Typography>
                      <Typography
                        sx={{
                          height: '56px',
                          backgroundColor: '#FFFFFF',
                          boxShadow: '0px 1px 6px 0px #00000026',
                          position: 'relative',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          marginTop: isFocusMode ? '20px' : '35px',
                          borderRadius: '5px',
                          width: '100%',
                        }}
                      >
                        <OfferInput
                          totalAmount={totalAmount}
                          setTotalAmount={setTotalAmount}
                          increment={increment}
                          formattedTotalAmount={formattedTotalAmount}
                          setFormattedTotalAmount={setFormattedTotalAmount}
                          icondis={iconDis}
                          setIconDis={setIconDis}
                          setPlaceholder={setPlaceholder}
                          placeholder={placeholder}
                          submitOfferHandler={submitOfferHandler}
                        />
                      </Typography>

                      {
                        <Typography
                          sx={{ marginTop: isFocusMode ? '3%' : '5%' }}
                        >
                          <Stack
                            sx={{
                              display: summaryView ? 'none' : 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                              gap: '7px',
                              justifyContent: 'space-between',
                            }}
                          >
                            <Stack
                              direction={'row'}
                              alignItems={'center'}
                              spacing={1}
                            >
                              <Checkbox
                                checked={isAutoOffer}
                                onClick={(e) => {
                                  setIsAutoOffer(!isAutoOffer);
                                  if (isAutoOffer) {
                                    if (
                                      getBuyerIndividualValue?.PropertyDetails
                                        ?.getBuyerLatestOfferDetails
                                        ?.isAutoOffer == 1
                                    ) {
                                      setMaximumOffer('');
                                      setOfferIncreament('');
                                      setSummaryView(true);
                                      return;
                                    }
                                    setMaximumOfferValidation(false);
                                    setOfferIncreamnetValidation(false);
                                    setMaximumOffer('');
                                    setOfferIncreament('');
                                  }
                                }}
                                sx={{
                                  width: '16.21px',
                                  height: '16.21px',
                                  '&.Mui-checked': {
                                    color: '#C4C4C4',
                                    backgroundColor: 'black',
                                  },
                                }}
                              />
                              <Typography
                                sx={{
                                  fontFamily: 'Poppins !important',
                                  fontStyle: 'normal !important',
                                  fontWeight: '500 !important',
                                  fontSize: '24px',
                                  color: '#000000',
                                }}
                              >
                                <MakeOfferLabel>Auto Offer</MakeOfferLabel>
                              </Typography>
                            </Stack>
                            <Stack flexDirection={'row'} alignItems={'center'}>
                              {!maximumOfferValidation &&
                                !offerIncreamnetValidation &&
                                !maximumOfferValidationTwo &&
                                maximumOffer !== '' &&
                                offerIncreamnet !== '' && (
                                  <Box
                                    sx={{
                                      display:
                                        isAutoOffer &&
                                        showSuccess &&
                                        !maximumOfferValidation &&
                                        !offerIncreamnetValidation &&
                                        !maximumOfferValidationTwo &&
                                        maximumOffer !== '' &&
                                        offerIncreamnet !== '' &&
                                        !offerIncreamnetError
                                          ? 'flex'
                                          : 'none',
                                      m: 1,
                                      position: 'relative',
                                    }}
                                  >
                                    <Fab
                                      disabled={
                                        (!maxChanged && incChanged) ||
                                        (!enableAction &&
                                          (!maximumOffer?.length ||
                                            !offerIncreamnet?.length))
                                      }
                                      aria-label="save"
                                      sx={{
                                        buttonSx,
                                        backgroundColor: '#FFFFFF',
                                      }}
                                      onClick={EditAutoOfferSummary}
                                      size="small"
                                    >
                                      <CheckIcon />
                                    </Fab>

                                    {saveLoading && (
                                      <img
                                        alt="Logo"
                                        src={Loading}
                                        className="loaderImage"
                                        style={{
                                          height: '40px',
                                          width: '40px',
                                        }}
                                      />
                                    )}
                                  </Box>
                                )}
                              <Box
                                sx={{
                                  display:
                                    isAutoOffer && showSuccess
                                      ? 'flex'
                                      : 'none',
                                }}
                              >
                                <Fab
                                  size="small"
                                  sx={{ backgroundColor: '#FFFFFF' }}
                                  onClick={fabSummaryClose}
                                >
                                  <KeyboardReturnRoundedIcon />
                                </Fab>
                              </Box>
                            </Stack>
                          </Stack>
                          {/* {isAutoOffer && !summaryView && ( */}
                          <Collapse
                            in={isAutoOffer && !summaryView}
                            timeout={400}
                            unmountOnExit
                          >
                            <Stack
                              spacing={isFocusMode ? 1 : 3}
                              sx={{ marginTop: isFocusMode ? '5px' : '25px' }}
                            >
                              <Box sx={{ marginTop: '25px' }}>
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins',
                                    textAlign: 'center',
                                    fontSize: 16,
                                    textTransform: 'capitalize',
                                    color: 'gray',
                                    marginBottom: '5px',
                                  }}
                                >
                                  Maximum Offer
                                </Typography>
                                <Typography
                                  direction={'row'}
                                  sx={{
                                    height: '56px',
                                    backgroundColor: '#FFFFFF',
                                    boxShadow: '0px 1px 6px 0px #00000026',
                                    marginTop: '4px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    borderRadius: '5px',
                                    position: 'relative',
                                    width: '100%',
                                    border:
                                      maximumOfferValidation && '1px solid red',
                                  }}
                                >
                                  <Stack>
                                    <IconButton
                                      onClick={maximumOfferDecrease}
                                      disabled={
                                        !maximumOffer || maximumOffer === '0'
                                      }
                                      sx={{
                                        position: 'absolute',
                                        top: '15px',
                                        left: '10px',
                                        p: 0,
                                        '&.Mui-disabled': {
                                          opacity: 0.3,
                                        },
                                      }}
                                    >
                                      <img
                                        src={Minus}
                                        alt="Minus"
                                        width={25.35}
                                        height={24}
                                      />
                                    </IconButton>
                                  </Stack>
                                  <Stack>
                                    <TextField
                                      variant="standard"
                                      autoComplete="off"
                                      InputProps={{
                                        disableUnderline: true,
                                        startAdornment: maximumOffer?.length >
                                          0 && (
                                          <InputAdornment
                                            position="start"
                                            sx={{
                                              transform: `translateX(calc(-${
                                                maximumOffer.length * 5
                                              }px + 130px))`,
                                            }}
                                          >
                                            <AttachMoneyIcon
                                              sx={{
                                                fontSize: '28px',
                                                color: '#666666',
                                              }}
                                            />
                                          </InputAdornment>
                                        ),
                                      }}
                                      inputProps={{
                                        style: {
                                          fontFamily: 'poppins',
                                          textAlign: 'center',
                                          fontSize: 20,
                                          color: '#666666',
                                          paddingLeft: '28px', // ✅ reserves space for icon
                                          caretColor: '#666666', // ✅ forces caret visibility in Firefox
                                        },
                                      }}
                                      sx={{
                                        fontFamily: 'Poppins !important',
                                        fontStyle: 'normal !important',
                                        fontWeight: '400 !important',
                                        fontSize: '26px',
                                        color: '#666666',
                                        width: '280px',
                                        border: 'none',
                                      }}
                                      label=""
                                      placeholder="Maximum Offer"
                                      value={
                                        maximumOffer?.length > 0
                                          ? `${maximumOffer ?? ''}`
                                          : maximumOffer
                                      }
                                      onChange={maximumOfferhandleChange}
                                    />
                                  </Stack>
                                  <Stack>
                                    <IconButton
                                      onClick={maximumOfferIncrease}
                                      sx={{
                                        position: 'absolute',
                                        top: '15px',
                                        right: '20px',
                                        p: 0,
                                      }}
                                    >
                                      <img
                                        src={Plus}
                                        alt="Plus"
                                        width={25.35}
                                        height={24}
                                      />
                                    </IconButton>
                                  </Stack>
                                </Typography>

                                {maximumOfferValidationTwo && (
                                  <Typography
                                    sx={{
                                      color:
                                        maximumOfferValidationTwo && '#f44336',
                                      fontFamily: 'poppins',
                                      fontSize: matchessm ? '12px' : '16px',
                                    }}
                                  >
                                    Your maximum offer must be at least equal to
                                    your last offer plus the{' '}
                                    {isMaximumOffer_MinOfferIncrement
                                      ? 'offer'
                                      : 'minimum'}{' '}
                                    increment of{' '}
                                    <b>
                                      $
                                      {isMaximumOffer_MinOfferIncrement
                                        ? offerIncreamnet
                                        : formatNumberWithCommas(increment)}
                                    </b>
                                    .
                                  </Typography>
                                )}
                                {maximumOfferValidation && (
                                  <Typography
                                    sx={{
                                      color:
                                        maximumOfferValidation && '#f44336',
                                      fontFamily: 'poppins',
                                      fontSize: matchessm ? '12px' : '16px',
                                    }}
                                  >
                                    Maximum Offer should be greater than Offer
                                    Price
                                  </Typography>
                                )}
                              </Box>
                              <Box sx={{ marginTop: '10px' }}>
                                <Typography
                                  sx={{
                                    fontFamily: 'Poppins',
                                    textAlign: 'center',
                                    fontSize: 16,
                                    textTransform: 'capitalize',
                                    color: 'gray',
                                  }}
                                >
                                  Offer Increment
                                </Typography>
                                <Typography
                                  direction={'row'}
                                  sx={{
                                    height: '56px',
                                    backgroundColor: '#FFFFFF',
                                    boxShadow: '0px 1px 6px 0px #00000026',
                                    marginTop: '4px',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    borderRadius: '5px',
                                    position: 'relative',
                                    width: '100%',
                                    border:
                                      offerIncreamnetValidation ||
                                      (offerIncreamnetError && '1px solid red'),
                                  }}
                                >
                                  <Stack>
                                    <IconButton
                                      onClick={OfferDecrease}
                                      disabled={
                                        !offerIncreamnet ||
                                        offerIncreamnet === '0'
                                      }
                                      sx={{
                                        position: 'absolute',
                                        top: '15px',
                                        left: '10px',
                                        p: 0,
                                        '&.Mui-disabled': {
                                          opacity: 0.3,
                                        },
                                      }}
                                    >
                                      <img
                                        src={Minus}
                                        alt="Minus"
                                        width={25.35}
                                        height={24}
                                      />
                                    </IconButton>
                                  </Stack>
                                  <Stack>
                                    <TextField
                                      variant="standard"
                                      autoComplete="off"
                                      InputProps={{
                                        disableUnderline: true,
                                        startAdornment:
                                          offerIncreamnet?.length > 0 && (
                                            <InputAdornment
                                              position="start"
                                              sx={{
                                                transform: `translateX(calc(-${
                                                  offerIncreamnet.length * 5
                                                }px + 130px))`,
                                              }}
                                            >
                                              <AttachMoneyIcon
                                                sx={{
                                                  fontSize: '28px',
                                                  color: '#666666',
                                                }}
                                              />
                                            </InputAdornment>
                                          ),
                                      }}
                                      inputProps={{
                                        style: {
                                          fontFamily: 'poppins',
                                          textAlign: 'center',
                                          fontSize: 20,
                                          color: '#666666',
                                          paddingLeft: '28px', // ✅ reserves space for icon
                                          caretColor: '#666666', // ✅ forces caret visibility in Firefox
                                        },
                                      }}
                                      label=""
                                      placeholder={'Offer Increment'}
                                      sx={{
                                        fontFamily: 'Poppins !important',
                                        fontStyle: 'normal !important',
                                        fontWeight: '400 !important',
                                        fontSize: '26px',
                                        color: '#666666',
                                        width: '280px',
                                        border: 'none',
                                      }}
                                      value={
                                        offerIncreamnet?.length > 0
                                          ? `${offerIncreamnet ?? ''}`
                                          : offerIncreamnet
                                      }
                                      onChange={OfferhandleChange}
                                    />
                                  </Stack>
                                  <Stack>
                                    <IconButton
                                      onClick={OfferIncrease}
                                      sx={{
                                        position: 'absolute',
                                        top: '15px',
                                        right: '20px',
                                        p: 0.5, // Adjust padding as needed
                                      }}
                                    >
                                      <img
                                        src={Plus}
                                        alt="Plus"
                                        style={{
                                          width: '25.35px',
                                          height: '24px',
                                        }}
                                      />
                                    </IconButton>
                                  </Stack>
                                </Typography>
                                {offerIncreamnetError && (
                                  <Typography
                                    sx={{
                                      color: offerIncreamnetError && '#f44336',
                                      fontFamily: 'poppins',
                                      fontSize: matchessm ? '12px' : '16px',
                                    }}
                                  >
                                    Offer Increment should be greater than the
                                    minimum increment of{' '}
                                    <b>${formatNumberWithCommas(increment)}</b>
                                  </Typography>
                                )}
                              </Box>
                            </Stack>
                          </Collapse>
                          <Collapse
                            in={summaryView}
                            timeout={400}
                            unmountOnExit
                          >
                            <Stack
                              spacing={2}
                              position={'relative'}
                              maxWidth={'100%'}
                            >
                              <Typography
                                sx={{
                                  ...poppins500,
                                  fontSize: matchessm ? '20px' : '24px',
                                }}
                              >
                                Auto Offer Summary
                              </Typography>
                              {autoOfferCancelled && (
                                <Stack
                                  flexDirection={'row'}
                                  alignItems={'center'}
                                  textAlign={'center'}
                                  gap={2}
                                  padding={'7px'}
                                  border={'1px solid #F39800'}
                                  borderRadius={'5px'}
                                  sx={{
                                    backgroundColor: '#f9ead2',
                                    position: 'relative',
                                  }}
                                >
                                  <CardActionArea
                                    onClick={() => setAutoOfferCancelled(false)}
                                    sx={{
                                      border: '1px solid #F39800',
                                      position: 'absolute',
                                      top: -4,
                                      right: -4,
                                      backgroundColor: '#fff',
                                      borderRadius: '20px',
                                      width: '20px',
                                      height: '20px',
                                      display: 'flex', // ✅ Added to enable centering
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      cursor: 'pointer',
                                      paddingLeft: '1px',
                                    }}
                                  >
                                    <CloseRoundedIcon sx={{ fontSize: 13 }} />
                                  </CardActionArea>

                                  <AutoOfferWaring />
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      fontWeight: 500,
                                      fontSize: '16px',
                                      color: '#F39800',
                                    }}
                                  >
                                    Auto Offer Cancelled
                                  </Typography>
                                </Stack>
                              )}
                              <Grid
                                sx={{
                                  background: isFocusMode
                                    ? '#FFFFFF'
                                    : '#FAFAFA',
                                  border:
                                    autoOfferCancelled && '1px solid #F39800',
                                }}
                              >
                                <Stack
                                  direction={'row'}
                                  justifyContent={'end'}
                                  position={'absolute'}
                                  right={5}
                                >
                                  <IconButton
                                    onClick={() => {
                                      setSummaryView(false);
                                      setIsAutoOffer(true);
                                      setShowSuccess(true);
                                      setEnableAction(false);
                                      setOfferIncreament(
                                        formatNumberWithCommas(
                                          getBuyerIndividualValue
                                            ?.PropertyDetails
                                            ?.getBuyerLatestOfferDetails
                                            ?.offerIncrementOne
                                        )
                                      );
                                      setMaximumOffer(
                                        formatNumberWithCommas(
                                          getBuyerIndividualValue
                                            ?.PropertyDetails
                                            ?.getBuyerLatestOfferDetails
                                            ?.offermaximumOfferOne
                                        )
                                      );
                                    }}
                                  >
                                    <EditIcon />
                                  </IconButton>
                                  <IconButton
                                    onClick={() => {
                                      setOpenDeleteAutoOffer(true);
                                      setShowSuccess(false);
                                    }}
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </Stack>
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  padding={2}
                                  mt={1}
                                >
                                  <Stack spacing={isFocusMode ? 3 : 6}>
                                    <Typography sx={offerSummaryText}>
                                      Maximum Offer:
                                    </Typography>
                                    <Typography sx={offerSummaryText}>
                                      Offer Increments:
                                    </Typography>
                                    <Typography sx={offerSummaryText}>
                                      Number of Offers:
                                    </Typography>
                                  </Stack>
                                  <Stack spacing={isFocusMode ? 3 : 6}>
                                    <Typography sx={offerSummaryValue}>
                                      {(() => {
                                        const val =
                                          getBuyerIndividualValue
                                            ?.PropertyDetails
                                            ?.getBuyerLatestOfferDetails
                                            ?.offermaximumOffer;
                                        if (!val) return '-';
                                        const formatted =
                                          formatNumberWithCommas(val);
                                        return String(val)
                                          .trim()
                                          .startsWith('$')
                                          ? `$${formatted}`
                                          : formatted;
                                      })()}
                                    </Typography>
                                    <Typography sx={offerSummaryValue}>
                                      {(() => {
                                        const val =
                                          getBuyerIndividualValue
                                            ?.PropertyDetails
                                            ?.getBuyerLatestOfferDetails
                                            ?.offerIncrement;
                                        if (!val) return '-';
                                        const formatted =
                                          formatNumberWithCommas(val);
                                        return String(val)
                                          .trim()
                                          .startsWith('$')
                                          ? `$${formatted}`
                                          : formatted;
                                      })()}
                                    </Typography>
                                    <Typography sx={offerSummaryValue}>
                                      {
                                        getBuyerIndividualValue?.PropertyDetails
                                          ?.getBuyerLatestOfferDetails
                                          ?.totalOfferCount
                                      }
                                    </Typography>
                                  </Stack>
                                </Stack>
                                <Stack
                                  direction={'row'}
                                  alignItems={'center'}
                                  mt={isFocusMode ? 1 : 2}
                                >
                                  <IconButton
                                    disableRipple
                                    sx={{ cursor: 'pointer' }}
                                  >
                                    <EyeCloseIcon />
                                  </IconButton>
                                  <Typography
                                    sx={{
                                      ...poppins400,
                                      fontSize: '12px',
                                      color: '#666666',
                                    }}
                                  >
                                    Auto Offer details are private to you and
                                    not visible to anyone.
                                  </Typography>
                                </Stack>
                              </Grid>
                            </Stack>
                          </Collapse>
                        </Typography>
                      }
                      {/* FocusMode Confitional Button */}
                      {isFocusMode && (
                        <Stack
                          sx={{
                            marginTop: isFocusMode ? '75px' : '380px',
                            position: isFocusMode ? 'fixed' : 'sticky',
                            bottom: isFocusMode ? '65px' : -29,
                            width: isFocusMode && '31%',
                          }}
                        >
                          <Stack direction={'column'} spacing={2.5}>
                            <Stack
                              direction={'row'}
                              textAlign={'center'}
                              spacing={3}
                            >
                              <Typography
                                sx={{
                                  ...poppins400,
                                  fontSize: '14px',
                                  color: '#666666',
                                }}
                              >
                                Select Offer Type
                              </Typography>
                              <Box>
                                <InfoIcon />
                              </Box>
                            </Stack>

                            <Stack
                              direction={'row'}
                              textAlign={'center'}
                              spacing={3}
                            >
                              <Button
                                sx={{
                                  textTransform: 'none',
                                  fontSize: '20px',
                                  fontFamily: poppins300,
                                  height: '58px',
                                  width: '229px',
                                  borderRadius: '8px',
                                  borderColor: !isFocusModeConditional
                                    ? '#2A3BD2'
                                    : 'inherit',
                                  color: !isFocusModeConditional
                                    ? '#2A3BD2'
                                    : 'white',
                                  backgroundColor:
                                    conditional &&
                                    !focusModeTermsDialogOpen &&
                                    '#58CBE41A',
                                }}
                                variant={
                                  focusModeTermsDialogOpen
                                    ? 'contained'
                                    : 'outlined'
                                }
                                onClick={() => {
                                  setConditional(true);
                                  handleOpenFocusModeTerms();
                                  setIsFocusModeConditional((prev) => !prev);
                                }}
                              >
                                Conditional
                              </Button>
                              <Button
                                sx={{
                                  textTransform: 'none',
                                  fontSize: '20px',
                                  fontFamily: poppins300,
                                  height: '58px',
                                  width: '229px',
                                  borderRadius: '8px',
                                  color: '#2A3BD2',
                                  borderColor: '#2A3BD2',
                                  backgroundColor:
                                    conditional === false
                                      ? matchessm
                                        ? '#2A3BD2'
                                        : '#58CBE41A'
                                      : '#FFFFFF',
                                }}
                                variant={'outlined'}
                                onClick={() => {
                                  if (
                                    (doc66wstatus == 0 ||
                                      (doc66wstatus == 1 && nextConditional)) &&
                                    ((stage == 'ST1'
                                      ? st1condition?.UnconditionalOnly == 1
                                      : st2condition?.UnconditionalOnly == 1) ||
                                      !nextConditional)
                                  ) {
                                    setConditional(false); // update first

                                    setTimeout(() => {
                                      setConditionalNotAvailable(true); // open popup AFTER state updates
                                    }, 0);
                                    return;
                                  }
                                  setConditional(false);
                                }}
                              >
                                Unconditional
                              </Button>
                            </Stack>
                          </Stack>
                          <Stack
                            direction={'row'}
                            alignItems={'center'}
                            justifyContent="space-between"
                            width="100%"
                            mt={isFocusMode && 1}
                          >
                            <Stack
                              sx={{
                                minWidth: isFocusMode ? '0px' : '250px',
                                flexGrow: 1,
                              }}
                            >
                              {/* Focus mode chart */}
                              {(!conditional ||
                                getBuyerIndividualValue?.PropertyDetails
                                  ?.timerStatus != 'Pause') &&
                                !hideOthers &&
                                !isRequestAccessLock && (
                                  <MeterChartOffer
                                    offerValue={
                                      offerValue ? offerValue : latestOfferPrice
                                    }
                                    priceEstimate={
                                      makeOfferListArray?.priceEstimate
                                    }
                                    isFocusMode={isFocusMode}
                                  />
                                )}
                            </Stack>
                            <Stack>
                              <Stack
                                onClick={() => {
                                  if (
                                    getBuyerIndividualValue?.PropertyDetails
                                      ?.timerStatus === 'Pause'
                                  )
                                    return;
                                  submitOfferHandler();
                                }}
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  height: matchessm ? '60px' : '50px',
                                  gap: '10px',
                                  width: matchessm ? '100%' : 'min-content',
                                  borderRadius: '5px',
                                  background:
                                    getBuyerIndividualValue?.PropertyDetails
                                      ?.timerStatus === 'End' ||
                                    getBuyerIndividualValue?.PropertyDetails
                                      ?.timerStatus === 'Pause'
                                      ? '#d9d9d9'
                                      : (conditional &&
                                          !maximumOfferValidation &&
                                          !offerIncreamnetValidation &&
                                          !offerIncreamnetError &&
                                          !emptyIncreamnetValidation &&
                                          (stage == 'ST1'
                                            ? st1condition?.UnconditionalOnly ==
                                              0
                                            : st2condition?.UnconditionalOnly ==
                                              0)) ||
                                        (!conditional &&
                                          doc66wstatus == 1 &&
                                          !maximumOfferValidation &&
                                          !offerIncreamnetValidation &&
                                          !offerIncreamnetError &&
                                          !emptyIncreamnetValidation)
                                      ? '#6C2AD2'
                                      : '#d9d9d9',
                                  flexDirection: 'row',
                                  padding: '6px 15px',
                                  marginTop: '10px',
                                  cursor:
                                    getBuyerIndividualValue?.PropertyDetails
                                      ?.timerStatus === 'End' ||
                                    getBuyerIndividualValue?.PropertyDetails
                                      ?.timerStatus === 'Pause'
                                      ? 'not-allowed'
                                      : (conditional &&
                                          !maximumOfferValidation &&
                                          !offerIncreamnetValidation &&
                                          !offerIncreamnetError &&
                                          !emptyIncreamnetValidation &&
                                          (stage == 'ST1'
                                            ? st1condition?.UnconditionalOnly ==
                                              0
                                            : st2condition?.UnconditionalOnly ==
                                              0)) ||
                                        (!conditional &&
                                          doc66wstatus == 1 &&
                                          !maximumOfferValidation &&
                                          !offerIncreamnetValidation &&
                                          !offerIncreamnetError &&
                                          !emptyIncreamnetValidation)
                                      ? 'pointer'
                                      : 'not-allowed',
                                }}
                              >
                                <Stack>
                                  <Typography
                                    sx={{
                                      width: '21px',
                                      height: '21px',
                                    }}
                                  >
                                    <Message />
                                  </Typography>
                                </Stack>
                                <Stack>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: matchessm ? 400 : 500,
                                      fontSize: matchessm ? '20px' : '16px',
                                      color: '#FFFFFF',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    Submit Offer
                                  </Typography>
                                </Stack>
                              </Stack>
                            </Stack>
                          </Stack>
                        </Stack>
                      )}
                    </Stack>
                  )
                )}
                {sharedpage && (
                  <Box>
                    <Box
                      sx={{
                        ...poppins500,
                        fontSize: '24px',
                        color: '#112347',
                        marginTop: matchessm ? '10px' : '65px',
                      }}
                    >
                      Watch the live action?
                    </Box>
                    <Box
                      sx={{
                        ...poppins300,
                        fontSize: '20px',
                        paddingTop: 8,
                        color: '#112347',
                      }}
                    >
                      Would you like to watch the real-time offers, as they
                      happens?
                    </Box>
                    <Box
                      sx={{
                        ...poppins300,
                        fontSize: '20px',
                        paddingTop: 4,
                        color: '#112347',
                      }}
                    >
                      Please log in for full access.
                    </Box>
                    <Stack
                      direction={'row'}
                      justifyContent={'start'}
                      gap={3}
                      sx={{ paddingTop: matchessm ? 10 : 14 }}
                    >
                      <Button
                        onClick={() => {
                          if (sharedpage) {
                            setOpenlogin(!openlogin);
                          }
                        }}
                        size="large"
                        style={{
                          fontFamily: 'poppins',
                          background: '#8651D9',
                          color: 'white',
                          fontSize: !matchesmd ? '16px' : '12px',
                          fontWeight: 400,
                          padding: !matchesmd ? '10px 60px' : '10px 30px',
                          borderRadius: '50px',
                          width: '197px',
                        }}
                      >
                        LOGIN
                      </Button>
                      <Button
                        onClick={() => {
                          history.push('/signup');
                        }}
                        size="large"
                        style={{
                          fontFamily: 'poppins',
                          color: '#8651D9',
                          fontSize: !matchesmd ? '16px' : '12px',
                          fontWeight: 400,
                          padding: '10px 60px',
                          borderRadius: '50px',
                          border: '1px solid #8651D9',
                          width: '197px',
                        }}
                      >
                        REGISTER
                      </Button>
                    </Stack>
                  </Box>
                )}
                {!graphAction &&
                  getBuyerIndividualValue?.PropertyDetails?.timerStatus ==
                    'Pause' && (
                    <Box
                      sx={{
                        width: '100%',
                        minHeight: matchessm ? '200px' : '400px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'poppins',
                          fontWeight: 500,
                          fontSize: '32px',
                          textAlign: 'center',
                        }}
                      >
                        P a u s e d
                      </Typography>

                      <Typography
                        sx={{
                          fontFamily: 'poppins',
                          fontWeight: 400,
                          fontSize: matchessm ? '14px' : '18px',
                          textAlign: 'center',
                          marginTop: 2,
                          color: '#555',
                        }}
                      >
                        Campaign will resume in
                      </Typography>

                      {remainingTime > 0 ? (
                        (() => {
                          const { days, hours, minutes, seconds } =
                            getTimeUnits(remainingTime);

                          return (
                            <Box mt={3}>
                              <Stack
                                direction="row"
                                spacing={2}
                                justifyContent="center"
                              >
                                {[days, hours, minutes, seconds].map(
                                  (value, index) => (
                                    <Box
                                      key={index}
                                      sx={{
                                        minWidth: '70px',
                                        height: '60px',
                                        borderRadius: '8px',
                                        backgroundColor: '#FFFFFF',
                                        boxShadow:
                                          '0px 4px 10px rgba(0,0,0,0.08)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontFamily: 'Poppins',
                                        fontSize: matchessm ? '18px' : '24px',
                                        fontWeight: 600,
                                        color: '#112347',
                                      }}
                                    >
                                      {String(value).padStart(2, '0')}
                                    </Box>
                                  )
                                )}
                              </Stack>

                              <Stack
                                direction="row"
                                spacing={2}
                                justifyContent="center"
                                mt={1}
                              >
                                {['D', 'H', 'M', 'S'].map((label) => (
                                  <Typography
                                    key={label}
                                    sx={{
                                      width: '70px',
                                      textAlign: 'center',
                                      fontFamily: 'Poppins',
                                      fontSize: '12px',
                                      fontWeight: 500,
                                      color: '#8A8A8A',
                                    }}
                                  >
                                    {label}
                                  </Typography>
                                ))}
                              </Stack>
                            </Box>
                          );
                        })()
                      ) : (
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            fontWeight: 600,
                            fontSize: matchessm ? '18px' : '24px',
                            textAlign: 'center',
                            marginTop: 2,
                            color: '#112347',
                          }}
                        ></Typography>
                      )}
                      <Typography
                        sx={{
                          fontFamily: 'poppins',
                          fontWeight: 400,
                          fontSize: matchessm ? '13px' : '15px',
                          textAlign: 'center',
                          marginTop: 3,
                          color: '#6B6B6B',
                          maxWidth: '420px',
                        }}
                      >
                        You cannot submit offers while the campaign is paused.
                        For assistance during this time, please contact the
                        selling agent.
                      </Typography>
                      <Button
                        onClick={() => {
                          if (isFocusMode) {
                            handleCloseFocus();
                            setIsBinderChatOpen(true);
                            directcomm(
                              getBuyerIndividualValue?.PropertyDetails
                                ?.agentDetails?.agentId
                            );
                          } else {
                            setIsBinderChatOpen(true);
                            directcomm(
                              getBuyerIndividualValue?.PropertyDetails
                                ?.agentDetails?.agentId
                            );
                          }
                        }}
                        size="large"
                        sx={{
                          marginTop: 2,
                          fontFamily: 'poppins',
                          color: '#529AEE',
                          fontSize: matchessm ? '14px' : '16px',
                          fontWeight: 500,
                          borderRadius: '5px',
                          width: matchessm ? '150px' : '180px',
                          height: '43px',
                          textTransform: 'capitalize',
                          border: '1px solid #529AEE',
                        }}
                      >
                        Contact Agent
                      </Button>
                    </Box>
                  )}
                {isRequestAccessLock && (
                  <Box sx={{ position: 'relative' }}>
                    <Box
                      sx={{
                        userSelect:
                          getBuyerIndividualValue?.PropertyDetails
                            ?.timerStatus == 'End' && 'none',
                        pointerEvents:
                          getBuyerIndividualValue?.PropertyDetails
                            ?.timerStatus == 'End' && 'none',
                        opacity:
                          getBuyerIndividualValue?.PropertyDetails
                            ?.timerStatus == 'End' && 0.4,
                        filter:
                          getBuyerIndividualValue?.PropertyDetails
                            ?.timerStatus == 'End' && 'blur(6px)',
                      }}
                    >
                      <Stack
                        direction={'row'}
                        alignItems={'center'}
                        spacing={2}
                        paddingTop={'67px'}
                      >
                        <LockIconSharePage />
                        <Stack
                          direction={'column'}
                          alignItems={'start'}
                          gap={1}
                        >
                          <Box
                            sx={{
                              ...poppins500,
                              fontSize: '24px',
                              color: '#112347',
                            }}
                          >
                            Request Access?
                          </Box>
                          <Typography
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              textAlign: 'center',
                              height: '20px',
                              padding: '3px 12px',
                              fontFamily: 'Poppins !important',
                              fontStyle: 'normal !important',
                              fontWeight: '600 !important',
                              fontSize: '12px',
                              color: '#FFFFFF',
                              borderRadius: '2px',
                              bgcolor: '#F93939',
                            }}
                          >
                            STAGE 2
                          </Typography>
                        </Stack>
                      </Stack>
                      <Box
                        sx={{
                          ...poppins300,
                          fontSize: matchessm ? '16px' : '20px',
                          paddingTop: 7,
                          color: '#112347',
                        }}
                      >
                        <span style={{ fontWeight: 500 }}>
                          Stage 2 has commenced,{' '}
                        </span>{' '}
                        but it appears you do not have access to participate.
                      </Box>
                      <Box
                        sx={{
                          ...poppins300,
                          fontSize: matchessm ? '16px' : '20px',
                          paddingTop: 4,
                          color: '#112347',
                        }}
                      >
                        Would you like to request access from the selling agent?
                      </Box>

                      {getBuyerIndividualValue?.PropertyDetails
                        ?.stageTwoCondition?.UnconditionalOnly === '1' && (
                        <>
                          {checkListArray?.map((item, index) => {
                            return (
                              item?.taskCode == 'RevCon001' &&
                              item?.taskStatus !== 'Completed' && (
                                <Stack
                                  key={`rev-${index}`}
                                  direction={'row'}
                                  alignItems={'center'}
                                  border={'1px solid #FF3B30'}
                                  padding={1}
                                  justifyContent={'space-between'}
                                  marginTop={'30px'}
                                >
                                  <Stack
                                    direction={'row'}
                                    spacing={2}
                                    alignItems={'center'}
                                  >
                                    <Box>
                                      <WarningIcon />
                                    </Box>
                                    <Typography
                                      sx={{
                                        color: '#FF3B30',
                                        ...poppins400,
                                        fontSize: '16px',
                                      }}
                                    >
                                      Please complete Contract Review
                                    </Typography>
                                  </Stack>
                                  <Tooltip
                                    disableHoverListener={viewContractCompleted}
                                    disableInteractive
                                    placement="top"
                                    arrow
                                    title={
                                      <Typography
                                        sx={{
                                          fontFamily: 'poppins',
                                          fontSize: '12px',
                                        }}
                                      >
                                        Please complete View Contract
                                      </Typography>
                                    }
                                  >
                                    <Typography
                                      onClick={() => {
                                        if (viewContractCompleted == false) {
                                          if (isFocusMode) {
                                            focusModeActionTabSwitching();
                                            handleCloseFocus();
                                            setTabDAta('2');
                                          } else {
                                            setTabDAta('2');
                                          }
                                        } else {
                                          setTypeofsolicitorpopup(
                                            'forwardContract'
                                          );
                                          setOpensolicitorpopup(true);
                                        }
                                      }}
                                      sx={{
                                        color: '#007AFF',
                                        ...poppins400,
                                        fontSize: '16px',
                                        cursor: 'pointer',
                                      }}
                                    >
                                      View
                                    </Typography>
                                  </Tooltip>
                                </Stack>
                              )
                            );
                          })}

                          {checkListArray?.map((item, index) => {
                            return (
                              item?.taskCode == '66W001' &&
                              item?.taskStatus !== 'Completed' && (
                                <Stack
                                  key={`66w-${index}`}
                                  direction={'row'}
                                  alignItems={'center'}
                                  border={'1px solid #FF3B30'}
                                  padding={1}
                                  justifyContent={'space-between'}
                                  marginTop={'10px'}
                                >
                                  <Stack
                                    direction={'row'}
                                    spacing={2}
                                    alignItems={'center'}
                                  >
                                    <Box>
                                      <WarningIcon />
                                    </Box>
                                    <Typography
                                      sx={{
                                        color: '#FF3B30',
                                        ...poppins400,
                                        fontSize: '16px',
                                      }}
                                    >
                                      Please complete s66W
                                    </Typography>
                                  </Stack>
                                  <Typography
                                    onClick={() => {
                                      setTypeofsolicitorpopup('request66w');
                                      setOpensolicitorpopup(true);
                                    }}
                                    sx={{
                                      color: '#007AFF',
                                      ...poppins400,
                                      fontSize: '16px',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    View
                                  </Typography>
                                </Stack>
                              )
                            );
                          })}
                        </>
                      )}

                      <Stack
                        direction={'row'}
                        sx={{ marginTop: '30px' }}
                        spacing={matchessm ? 0 : 4}
                        justifyContent={matchessm ? 'space-around' : ''}
                      >
                        <Button
                          className={loading ? 'full-btn-shimmer' : ''}
                          onClick={() => {
                            if (isEnded) return;
                            if (
                              isStageTwoRequested === 0 &&
                              (getBuyerIndividualValue?.PropertyDetails
                                ?.stageTwoCondition?.UnconditionalOnly ===
                                '0' ||
                                (getBuyerIndividualValue?.PropertyDetails
                                  ?.stageTwoCondition?.UnconditionalOnly ===
                                  '1' &&
                                  is66wCompleted &&
                                  isContractCompleted))
                            ) {
                              RequestStageTwo();
                            }
                          }}
                          disabled={
                            loading ||
                            isStageTwoRequested !== 0 ||
                            !(
                              getBuyerIndividualValue?.PropertyDetails
                                ?.stageTwoCondition?.UnconditionalOnly ===
                                '0' ||
                              (getBuyerIndividualValue?.PropertyDetails
                                ?.stageTwoCondition?.UnconditionalOnly ===
                                '1' &&
                                is66wCompleted &&
                                isContractCompleted)
                            )
                          }
                          disableRipple={
                            isEnded ||
                            loading ||
                            isStageTwoRequested !== 0 ||
                            !(
                              getBuyerIndividualValue?.PropertyDetails
                                ?.stageTwoCondition?.UnconditionalOnly ===
                                '0' ||
                              (getBuyerIndividualValue?.PropertyDetails
                                ?.stageTwoCondition?.UnconditionalOnly ===
                                '1' &&
                                is66wCompleted &&
                                isContractCompleted)
                            )
                          }
                          size="large"
                          style={{
                            cursor: isEnded
                              ? 'default'
                              : loading
                              ? 'not-allowed'
                              : isStageTwoRequested !== 0
                              ? 'not-allowed'
                              : getBuyerIndividualValue?.PropertyDetails
                                  ?.stageTwoCondition?.UnconditionalOnly ===
                                  '0' ||
                                (getBuyerIndividualValue?.PropertyDetails
                                  ?.stageTwoCondition?.UnconditionalOnly ===
                                  '1' &&
                                  is66wCompleted &&
                                  isContractCompleted)
                              ? 'pointer'
                              : 'not-allowed',
                            pointerEvents: 'auto',
                            fontFamily: 'Poppins',
                            background:
                              isStageTwoRequested !== 0
                                ? 'lightgray'
                                : getBuyerIndividualValue?.PropertyDetails
                                    ?.stageTwoCondition?.UnconditionalOnly ===
                                    '0' ||
                                  (getBuyerIndividualValue?.PropertyDetails
                                    ?.stageTwoCondition?.UnconditionalOnly ===
                                    '1' &&
                                    is66wCompleted &&
                                    isContractCompleted)
                                ? '#33A745'
                                : 'lightgray',
                            color: 'white',
                            fontSize: !matchesmd ? '16px' : '14px',
                            fontWeight: 500,
                            borderRadius: '5px',
                            width: 'auto',
                            height: '43px',
                            textTransform: 'capitalize',
                          }}
                        >
                          <span>
                            {isStageTwoRequested === 0
                              ? 'Request Access'
                              : 'Access Pending'}
                          </span>
                        </Button>

                        <Button
                          onClick={() => {
                            if (isFocusMode) {
                              handleCloseFocus();
                              setIsBinderChatOpen(true);
                              directcomm(
                                getBuyerIndividualValue?.PropertyDetails
                                  ?.agentDetails?.agentId
                              );
                            } else {
                              setIsBinderChatOpen(true);
                              directcomm(
                                getBuyerIndividualValue?.PropertyDetails
                                  ?.agentDetails?.agentId
                              );
                            }
                          }}
                          size="large"
                          style={{
                            display: 'flex', // ✅ ALWAYS SHOW BUTTON
                            fontFamily: 'poppins',
                            color: '#529AEE',
                            fontSize: !matchesmd ? '16px' : '14px',
                            fontWeight: 500,
                            borderRadius: '5px',
                            width: matchessm ? '150px' : '179px',
                            height: '43px',
                            textTransform: 'capitalize',
                            border: '1px solid #529AEE',
                          }}
                        >
                          Contact Agent
                        </Button>
                      </Stack>

                      {isStageTwoRequested !== 0 && (
                        <Box
                          sx={{
                            ...poppins300,
                            fontSize: matchessm ? '16px' : '20px',
                            paddingTop: 4,
                            color: '#112347',
                          }}
                        >
                          You will be notified once access is granted. For more
                          info contact agent.
                        </Box>
                      )}
                    </Box>
                  </Box>
                )}
                {showOverlayEnded && (
                  <Box
                    sx={{
                      width: '100%',
                      minHeight: matchessm ? '200px' : '400px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: matchessm ? 'flex-start' : 'center',
                      pt: matchessm ? 2 : 0,
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: 'poppins',
                        fontWeight: 500,
                        fontSize: '32px',
                        textAlign: 'center',
                        letterSpacing: '8px',
                      }}
                    >
                      Ended
                    </Typography>
                  </Box>
                )}
                {showFullEnded && (
                  <Box
                    sx={{
                      width: '100%',
                      minHeight: matchessm ? '200px' : '400px',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: matchessm ? 'flex-start' : 'center',
                      pt: matchessm ? 2 : 0,
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: 'poppins',
                        fontWeight: 500,
                        fontSize: '32px',
                        textAlign: 'center',
                        letterSpacing: '8px',
                      }}
                    >
                      Ended
                    </Typography>
                  </Box>
                )}
              </Grid>
            </Stack>
          </Stack>
        }

        {getBuyerIndividualValue?.PropertyDetails?.timerStatus !== 'End' &&
          getBuyerIndividualValue?.PropertyDetails?.stage == 'ST2' &&
          !isStageTwoRequested == 1 &&
          !isFocusMode && (
            <Grid
              container
              sx={{
                display: matchessm ? 'none' : 'flex',
                justifyContent: 'space-around',
                padding: '10px 0 10px 0',
              }}
            >
              <Grid item></Grid>
              <Grid
                item
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1,
                }}
              >
                <Box>
                  <FocusModeIocnBlack />
                </Box>
                <Typography
                  onClick={() => setOpenFocusDialog(true)}
                  sx={{
                    fontFamily: 'Poppins, sans-serif',
                    fontWeight: 500,
                    fontSize: '18px',
                    color: '#6C2AD2',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                  }}
                >
                  Try Focus Mode
                </Typography>
              </Grid>
            </Grid>
          )}
        {getBuyerIndividualValue?.PropertyDetails?.timerStatus !== 'End' && (
          <div style={{ display: isFocusMode && 'none' }}>
            <Collapse
              sx={{ mt: 3 }}
              in={
                !hideOthers &&
                !sharedpage &&
                getBuyerIndividualValue?.PropertyDetails?.timerStatus !=
                  'Pause' &&
                showMeterChart &&
                !isRequestAccessLock
              }
              timeout={400}
              unmountOnExit
            >
              <MeterChartOffer
                offerValue={offerValue ? offerValue : latestOfferPrice}
                priceEstimate={makeOfferListArray?.priceEstimate}
              />
            </Collapse>

            {conditional &&
              !(
                (doc66wstatus == 0 || (doc66wstatus == 1 && conditional)) &&
                (stage == 'ST1'
                  ? st1condition?.UnconditionalOnly == 1
                  : st2condition?.UnconditionalOnly == 1)
              ) &&
              getBuyerIndividualValue?.PropertyDetails?.timerStatus !==
                'End' && (
                <Stack
                  sx={{
                    display: matchessm && 'none',
                    margin: matches400 && '10px',
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '500 !important',
                      fontSize: '24px',
                      color: '#000000',
                      marginTop: '30px',
                    }}
                  >
                    {conditional && (
                      <MakeOfferLabel>Preferred Terms</MakeOfferLabel>
                    )}
                  </Typography>
                </Stack>
              )}

            {!hideOthers && (
              <Grid
                container
                sx={{
                  display: 'flex',
                  flexDirection: matchessm ? 'row' : 'row-reverse',
                  justifyContent: 'space-between',
                  marginTop: '30px',
                }}
              >
                <Grid
                  xs={5.8}
                  onClick={() => {
                    if (
                      getBuyerIndividualValue?.PropertyDetails?.timerStatus ===
                      'End'
                    )
                      return;
                    if (isConditionalChanceCompleted == 1) {
                      setOpenCampaignRestrictedPopup(true);
                    } else {
                      setConditional(true);
                    }
                  }}
                  sx={{
                    filter:
                      isConditionalChanceCompleted == 1 ? 'blur(1px)' : 'none',
                    pointerEvents: 'auto',
                  }}
                >
                  <Stack
                    flexDirection={'column'}
                    sx={{
                      height: '60px',
                      border:
                        isConditionalChanceCompleted == 1
                          ? 'none'
                          : '1px solid #2A3BD2',
                      backgroundColor:
                        isConditionalChanceCompleted == 1
                          ? '#f0f0f0'
                          : conditional === true
                          ? matchessm
                            ? '#2A3BD2'
                            : '#58CBE41A'
                          : '#FFFFFF',
                      borderRadius: '8px',
                      cursor:
                        getBuyerIndividualValue?.PropertyDetails
                          ?.timerStatus === 'End'
                          ? 'not-allowed'
                          : 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Typography>
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: matchessm ? 300 : 400,
                          fontSize: '20px',
                          color:
                            isConditionalChanceCompleted == 1
                              ? '#666666'
                              : conditional === true
                              ? matchessm
                                ? '#FFFFFF'
                                : '#2A3BD2'
                              : '#2A3BD2',
                          textAlign: 'center',
                        }}
                      >
                        Conditional
                      </Typography>
                    </Typography>
                  </Stack>
                </Grid>
                <Grid
                  xs={5.8}
                  onClick={() => {
                    if (
                      getBuyerIndividualValue?.PropertyDetails?.timerStatus ===
                      'End'
                    )
                      return;
                    setConditional(false);
                  }}
                  sx={{
                    cursor:
                      getBuyerIndividualValue?.PropertyDetails?.timerStatus ===
                      'End'
                        ? 'not-allowed'
                        : 'pointer',
                  }}
                >
                  <Stack
                    sx={{
                      height: '60px',
                      border: '1px solid #2A3BD2',
                      pointerEvents: 'none',
                      backgroundColor:
                        conditional === false
                          ? matchessm
                            ? '#2A3BD2'
                            : '#58CBE41A'
                          : '#FFFFFF',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Stack>
                      <Typography>
                        <Typography
                          sx={{
                            fontFamily: 'Poppins !important',
                            fontStyle: 'normal !important',
                            fontWeight: matchessm ? 300 : 400,
                            fontSize: '20px',
                            color:
                              conditional === false
                                ? matchessm
                                  ? '#FFFFFF'
                                  : '#2A3BD2'
                                : '#2A3BD2',
                          }}
                        >
                          Unconditional{' '}
                        </Typography>
                      </Typography>
                    </Stack>
                    {!doc66wstatus && (
                      <Stack sx={{ display: matchessm && 'none' }}>
                        <Typography>
                          <Typography
                            sx={{
                              fontFamily: 'Poppins !important',
                              fontStyle: 'normal !important',
                              fontWeight: '300 !important',
                              fontSize: '10px',
                              color:
                                doc66wstatus == 0 && !matchessm
                                  ? '#2A3BD2'
                                  : doc66wstatus == 1 &&
                                    conditional &&
                                    !matchessm
                                  ? '#2A3BD2'
                                  : conditional === false
                                  ? '#FFFFFF'
                                  : '#2A3BD2',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            (Not available yet)
                          </Typography>
                        </Typography>
                      </Stack>
                    )}
                  </Stack>
                </Grid>
              </Grid>
            )}

            {!hideOthers && (
              <Stack
                sx={{
                  display: !matchessm && 'none',
                  margin: matches400 && '10px',
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '500 !important',
                    fontSize: '24px',
                    color: '#000000',
                    marginTop: '30px',
                  }}
                >
                  {conditional && (
                    <MakeOfferLabel>Preferred Terms</MakeOfferLabel>
                  )}
                </Typography>
              </Stack>
            )}
            {conditional &&
              !(
                (doc66wstatus == 0 || (doc66wstatus == 1 && conditional)) &&
                (stage == 'ST1'
                  ? st1condition?.UnconditionalOnly == 1
                  : st2condition?.UnconditionalOnly == 1)
              ) &&
              getBuyerIndividualValue?.PropertyDetails?.timerStatus !==
                'End' && (
                <ConditionalTerms
                  makeOfferListArray={makeOfferListArray}
                  hideOthers={hideOthers}
                  setSelectedConditionCodes={setSelectedConditionCodes}
                  setSettlementDays={setSettlementDays}
                  setDepositAmount={setDepositAmount}
                  setStateIndex={setStateIndex}
                  handleClickOpen={handleClickOpen}
                  subtoAddSelected={subtoAddSelected}
                  selectedItems={selectedItems}
                  setSelectedItems={setSelectedItems}
                  setDepAmount={setDepAmount}
                  setSettleDays={setSettleDays}
                  resetTerms={resetTerms}
                  setResetTerms={setResetTerms}
                  identicalsuggestion={identicalsuggestion}
                  setSubtoAddSelected={setSubtoAddSelected}
                  setAdditionalComment={setAdditionalComment}
                  sharedpage={sharedpage}
                />
              )}
            {/* Individual Unconditional Warning component */}
            <UnConditionalWarningcomponent
              doc66wstatus={doc66wstatus}
              conditional={conditional}
              stage={stage}
              st1condition={st1condition}
              st2condition={st2condition}
              matchessm={matchessm}
              hideOthers={hideOthers}
              matchesmd={matchesmd}
              sharedpage={sharedpage}
              setOpenlogin={setOpenlogin}
              openlogin={openlogin}
              setConditional={setConditional}
              setOpensolicitorpopup={setOpensolicitorpopup}
              setTypeofsolicitorpopup={setTypeofsolicitorpopup}
              isPause={isPause}
            />
            {!hideOthers && (
              <Grid
                container
                sx={{
                  display: 'flex',
                  justifyContent: 'end',
                  flexWrap: 'wrap',
                  marginTop: '60px',
                  gap: '20px',
                }}
              >
                <Fade
                  in={selectedItems?.length > 0 && conditional && !matchessm}
                  timeout={500}
                >
                  <Box>
                    <Button
                      onClick={() => setResetTerms(true)}
                      variant="contained"
                      sx={{
                        backgroundColor: '#F0E9FA',
                        height: '51px',
                        color: '#6C2AD2',
                        marginTop: '12px',
                        boxShadow: 'none',
                        textTransform: 'capitalize',
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '500 !important',
                        fontSize: '16px',
                        '&:hover': {
                          backgroundColor: '#F0E9FA',
                          color: '#6C2AD2',
                          boxShadow: 'none',
                        },
                      }}
                    >
                      Reset terms
                    </Button>
                  </Box>
                </Fade>
                {!matchessm && stage !== 'ST2' && (
                  <Stack
                    sx={{
                      width: 'auto',
                      borderRadius: '8px',
                      background: '#FFFFFF',
                      flexDirection: 'row',
                    }}
                  >
                    <Stack>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker']}>
                          <DateTimePicker
                            slotProps={{
                              textField: {
                                placeholder: 'Set Offer Expiry',
                                onFocus: () => setIsFocusedofferexpiry(true),
                                onBlur: () => setIsFocusedofferexpiry(false),
                                fullWidth: true,
                                required: true,
                                size: 'large',
                                InputLabelProps: {
                                  style: { fontFamily: 'Poppins' },
                                  shrink: true,
                                },
                                sx: {
                                  fontFamily: 'Poppins',
                                  fontWeight: 800,
                                  '& label.Mui-error': {
                                    color: 'lightgrey',
                                  },
                                  '& .MuiFormHelperText-root.Mui-error': {
                                    color: 'lightgrey',
                                  },
                                  '& .MuiOutlinedInput-root': {
                                    '&.Mui-error .MuiOutlinedInput-notchedOutline':
                                      {
                                        borderColor: 'lightgrey',
                                      },
                                  },
                                },
                              },
                            }}
                            format="DD-MM-YYYY hh:mm A"
                            label={
                              isFocusedofferexpiry || offerExpiryValue
                                ? 'Offer Expiry'
                                : ''
                            }
                            required
                            disabled={
                              getBuyerIndividualValue?.PropertyDetails
                                ?.timerStatus === 'End'
                            }
                            minDateTime={dayjs().add(24, 'hour')}
                            value={offerExpiryValue}
                            onChange={(newValue) => {
                              if (dayjs(newValue).isValid()) {
                                const now = dayjs();
                                const selected = dayjs(newValue);
                                const selectedFormat =
                                  dayjs(newValue).format('DD-MM-YYYY hh:mm A');
                                const tomorrow = now
                                  .add(1, 'day')
                                  .startOf('day')
                                  .format('DD-MM-YYYY hh:mm A');

                                let isTomorrow = false;

                                if (selectedFormat == tomorrow) {
                                  isTomorrow = true;
                                }

                                const updatedValue = isTomorrow
                                  ? selected
                                      .hour(now.hour())
                                      .minute(now.minute())
                                  : selected;

                                setOfferExpiryValue(updatedValue);
                                setOfferExpiry(
                                  updatedValue.format('DD-MM-YYYY hh:mm A')
                                );
                              } else {
                                setOfferExpiry('');
                              }
                            }}
                            className="custom-label-style"
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </Stack>
                  </Stack>
                )}
                {!matchessm && (
                  <Stack
                    sx={{
                      borderRadius: '5px',
                      background: isBestOffer ? '#6C2AD2' : '#6C2AD21A',
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: '10px',
                      padding: '6px 15px',
                      cursor:
                        getBuyerIndividualValue?.PropertyDetails
                          ?.timerStatus === 'End'
                          ? 'not-allowed'
                          : 'pointer',
                      marginTop: '10px',
                    }}
                    onClick={() => {
                      if (
                        getBuyerIndividualValue?.PropertyDetails
                          ?.timerStatus === 'End'
                      )
                        return;
                      setIsBestOffer(!isBestOffer);
                    }}
                  >
                    <Stack>
                      {isBestOffer ? (
                        <HighStar />
                      ) : (
                        <img
                          src={staricon}
                          alt="staricon"
                          style={{
                            width: '24px',
                            height: '24px',
                          }}
                        />
                      )}
                    </Stack>
                    <Stack>
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '500 !important',
                          fontSize: '16px',
                          color: isBestOffer ? 'white' : '#6C2AD2',
                        }}
                      >
                        Best & Final Offer
                      </Typography>
                    </Stack>
                  </Stack>
                )}
                {
                  <Stack
                    onClick={() => {
                      if (
                        getBuyerIndividualValue?.PropertyDetails
                          ?.timerStatus === 'End' ||
                        getBuyerIndividualValue?.PropertyDetails
                          ?.timerStatus === 'Pause'
                      )
                        return;
                      if (!isOfferAllowed) return;
                      if (totalAmount == '0') {
                        handleMakeOffer();
                      } else if (
                        parseFloat(totalAmount) < parseFloat(minimumValidOffer)
                      ) {
                        handleMakeOffer();
                      } else if (summaryView && totalAmount) {
                        if (continueLog) {
                          Swal.fire({
                            title: 'Offer Error',
                            text: 'Maximum Offer should be greater than offer price',
                            icon: 'error',
                            confirmButtonText: 'Close',
                          }).then(() => {
                            if (targetRef.current) {
                              targetRef.current.scrollIntoView({
                                behavior: 'smooth',
                              });
                            }
                            setOfferIncreament(
                              formatNumberWithCommas(
                                getBuyerIndividualValue?.PropertyDetails
                                  ?.getBuyerLatestOfferDetails.offerIncrementOne
                              )
                            );
                            setMaximumOffer(
                              formatNumberWithCommas(
                                getBuyerIndividualValue?.PropertyDetails
                                  ?.getBuyerLatestOfferDetails
                                  .offermaximumOfferOne
                              )
                            );
                            setSummaryView(false);
                            setIsAutoOffer(true);
                            setShowSuccess(true);
                          });

                          return;
                        } else {
                          setContinueTheseOffer(true);
                        }
                      } else {
                        handleMakeOffer();
                      }
                    }}
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'center',
                      height: matchessm ? '60px' : '50px',
                      gap: '10px',
                      width: matchessm ? '100%' : 'min-content',
                      borderRadius: '5px',
                      background:
                        getBuyerIndividualValue?.PropertyDetails
                          ?.timerStatus === 'End' ||
                        getBuyerIndividualValue?.PropertyDetails
                          ?.timerStatus === 'Pause'
                          ? '#d9d9d9'
                          : (conditional &&
                              !maximumOfferValidation &&
                              !offerIncreamnetValidation &&
                              !offerIncreamnetError &&
                              !emptyIncreamnetValidation &&
                              (stage == 'ST1'
                                ? st1condition?.UnconditionalOnly == 0
                                : st2condition?.UnconditionalOnly == 0)) ||
                            (!conditional &&
                              doc66wstatus == 1 &&
                              !maximumOfferValidation &&
                              !offerIncreamnetValidation &&
                              !offerIncreamnetError &&
                              !emptyIncreamnetValidation)
                          ? '#6C2AD2'
                          : '#d9d9d9',
                      padding: '28px 15px',
                      marginTop: '10px',
                      cursor:
                        getBuyerIndividualValue?.PropertyDetails
                          ?.timerStatus === 'End' ||
                        getBuyerIndividualValue?.PropertyDetails
                          ?.timerStatus === 'Pause'
                          ? 'not-allowed'
                          : (conditional &&
                              !maximumOfferValidation &&
                              !offerIncreamnetValidation &&
                              !offerIncreamnetError &&
                              !emptyIncreamnetValidation &&
                              (stage == 'ST1'
                                ? st1condition?.UnconditionalOnly == 0
                                : st2condition?.UnconditionalOnly == 0)) ||
                            (!conditional &&
                              doc66wstatus == 1 &&
                              !maximumOfferValidation &&
                              !offerIncreamnetValidation &&
                              !offerIncreamnetError &&
                              !emptyIncreamnetValidation)
                          ? 'pointer'
                          : 'not-allowed',
                    }}
                  >
                    <Stack>
                      <Typography
                        sx={{
                          width: '21px',
                          height: '21px',
                        }}
                      >
                        <Message />
                      </Typography>
                    </Stack>
                    <Stack>
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: matchessm ? 400 : 500,
                          fontSize: matchessm ? '20px' : '16px',
                          color: '#FFFFFF',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Submit Offer
                      </Typography>
                    </Stack>
                  </Stack>
                }
                {matchessm && (
                  <Button
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      width: '100%',
                      background: 'white',
                      border: '1px solid red',
                      height: '60px',
                      color: 'red',
                      fontFamily: 'Poppins',
                      fontSize: '20px',
                      fontWeight: 400,
                      textTransform: 'capitalize',
                      boxShadow: 'none',
                    }}
                    onClick={() => {
                      setTabDAta('0');
                      setNewTabData(false);
                      SetHideOthers(false);
                      setShowPropertyTimer(false);
                    }}
                    variant="contained"
                  >
                    Cancel
                  </Button>
                )}
              </Grid>
            )}
          </div>
        )}
      </Card>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={'md'}
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              width: '100%',
              maxWidth: '500px',
              fontFamily: 'Poppins',
            },
          },
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            ...poppins500,
            fontFamily: 'Poppins',
          }}
        >
          Additional Conditions
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            value={addictionComment}
            onChange={(e) => {
              const value = e.target.value;
              const capitalized =
                value.charAt(0).toUpperCase() + value.slice(1);
              setAdditionalComment(capitalized);

              if (error) setError(false);
            }}
            error={error}
            inputProps={{
              maxLength: 100,
            }}
            helperText={
              error
                ? 'Please enter additional conditions'
                : `${addictionComment.length}/100`
            }
            sx={{
              mt: 1,

              '& .MuiInputBase-input': {
                fontFamily: 'Poppins',
                fontSize: '14px',
              },
              '& .MuiFormHelperText-root': {
                fontFamily: 'Poppins, sans-serif',
                fontSize: '12px',
              },
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#fff',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#c4c4c4',
              },
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            sx={{
              ...poppins300,
              fontFamily: 'Poppins',
              padding: '10px 20px',
              height: '35px',
              fontSize: '14px',
              border: '1px solid rgba(17, 35, 71, 0.1)',
              color: '#666666',
              textTransform: 'none',
              '&:hover': {
                border: '1px solid rgba(17, 35, 71, 0.2)',
              },
            }}
            onClick={handleClose}
          >
            Close
          </Button>

          <Button
            variant="contained"
            sx={{
              ...poppins300,
              fontFamily: 'Poppins',
              padding: '10px 20px',
              height: '35px',
              fontSize: '14px',
              backgroundColor: '#4CA4D6',
              textTransform: 'none',
              border: '1px solid #4CA4D6',
              '&:hover': {
                backgroundColor: '#4CA4D6',
                border: '1px solid #3A92C3',
              },
            }}
            onClick={handleSubmit}
            autoFocus
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={continueAutOffer}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '20px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Confirm Auto Offer Summary
            </Typography>
          </Grid>
          <Grid item md={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
                marginTop: '50px',
              }}
            >
              Do you continue with these auto-offer details?{' '}
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? '15px' : 5}
          >
            <Grid item>
              <Button
                onClick={() => {
                  setContinueAutOffer(false);
                }}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <Button
                onClick={() => {
                  setOpenCard(!openCard);
                  setContinueAutOffer(false);
                }}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Confirm
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        open={openCancel}
        onClose={() => setOpenCancel(false)}
        PaperProps={{
          sx: {
            height: isSmallHeight ? '460px' : matchessm ? 'auto' : '650px',
            borderRadius: '8px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '20px' : '30px',
          },
        }}
        zIndex={200000}
      >
        <Grid container>
          <Grid item>
            <Typography
              sx={{
                fontFamily: 'poppins!important',
                fontSize: matchessm ? '10px' : '14px!important',
                fontWeight: 400,
                color: '#666666',
              }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
            </Typography>

            <Grid item display={'flex'} alignItems={'center'}>
              <Redwarning />
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matchessm ? '16px' : '24px',
                  color: '#000000',
                }}
              >
                <Grid
                  item
                  display={'flex'}
                  alignItems={'center'}
                  padding={'12px 0px 15px 0'}
                >
                  <Typography
                    sx={{
                      ...poppins500,
                      fontSize: matchessm ? '16px' : '24px',
                      paddingLeft: '8px',
                      color: '#000000',
                    }}
                  >
                    Offer Cancelled
                  </Typography>
                </Grid>
              </Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: 'poppins!important',
                  fontSize: matchessm ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#666666',
                  justifyContent: 'center',
                  alignItems: 'center',

                  marginTop: '0px',
                  marginLeft: '3px',
                  justifyItems: 'self-end',
                }}
              >
                Your offer{' '}
                <span>
                  <b
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    $
                    {parseFloat(totalAmount).toLocaleString('en-US', {
                      maximumFractionDigits: 2,
                    })}
                  </b>
                </span>{' '}
                has been cancelled and will not be submitted for consideration.
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            sx={{
              paddingTop: matchessm ? '30px' : '40px',
              marginTop: '10px',
              borderTop: '1px solid #D9D9D9',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Ellipse isSmallHeight={isSmallHeight} />
          </Grid>

          <Grid
            container
            gap={2}
            marginTop={matchessm ? '30px' : '40px'}
            justifyContent={'end'}
          >
            <Grid item sx={{ marginTop: '8px' }}></Grid>
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={() => {
                  setShowTick(false);
                  setAcceptterms(false);
                  setOpenBox(false);
                  setOpenCard(false);
                  setOpenCancel(false);
                  setOfferExp(null);
                  setIsBestOffer(false);
                  setIsAutoOffer(false);
                  setTotalAmount(0);
                  setMaximumOffer('');
                  setOfferIncreament('');
                }}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
      <Dialog
        open={confirmCancel}
        onClose={() => setConfirmCancel(!confirmCancel)}
        PaperProps={{
          sx: {
            height: isSmallHeight ? 'auto' : matchessm ? 'auto' : 'auto',
            borderRadius: '8px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: '30px',
          },
        }}
        zIndex={200000}
      >
        <Grid container>
          <Grid item>
            <Typography
              sx={{
                fontFamily: 'poppins!important',
                fontSize: matchessm ? '10px' : '14px!important',
                fontWeight: 400,
                color: '#666666',
              }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
            </Typography>

            <Grid item display={'flex'} alignItems={'center'}>
              <Pendingwarning />
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matchessm ? '16px' : '24px',
                  color: '#000000',
                }}
              >
                <Grid
                  item
                  display={'flex'}
                  alignItems={'center'}
                  padding={'12px 0px 15px 0'}
                >
                  <Typography
                    sx={{
                      ...poppins500,
                      fontSize: matchessm ? '16px' : '24px',
                      paddingLeft: '8px',
                      color: '#000000',
                    }}
                  >
                    Cancel Offer
                  </Typography>
                </Grid>
              </Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: 'poppins!important',
                  fontSize: matchessm ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#666666',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginTop: '0px',
                  marginLeft: '3px',
                  justifyItems: 'self-end',
                }}
              >
                Would you like to cancel your offer of{' '}
                <span>
                  <b
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    $
                    {parseFloat(totalAmount).toLocaleString('en-US', {
                      maximumFractionDigits: 2,
                    })}
                  </b>
                </span>
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            gap={2}
            marginTop={matchessm ? '60px' : '20px'}
            justifyContent={'end'}
          >
            <Grid item sx={{ marginTop: '8px' }}></Grid>
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
                onClick={() => {
                  setConfirmCancel(!confirmCancel);
                  setOpenCard(true);
                }}
              >
                Back
              </Button>
            </Grid>
            <Grid item onClick={cancelOffer}>
              <Button
                variant="outlined"
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: matchesmd ? '12px' : '14px',
                  backgroundColor: '#4CA4D6',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Yes
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        open={openDeleteAutoOffer}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '20px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Delete Auto Offer Details
            </Typography>
          </Grid>
          <Grid item md={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
                marginTop: '50px',
              }}
            >
              Do you want to delete the existing Auto Offer Details?{' '}
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? '15px' : 5}
          >
            <Grid item>
              <Button
                disabled={deleteOfferLoading}
                onClick={() => {
                  setOpenDeleteAutoOffer(false);
                }}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <Button
                disabled={deleteOfferLoading}
                onClick={() => {
                  DeleteAutoOfferSummary(false);
                }}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Confirm
              </Button>
              {deleteOfferLoading && (
                <img
                  alt="Loading"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '30px', width: '30px' }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      <Dialog
        open={continueTheseOffer}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '20px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
            </Typography>
            <IconButton onClick={() => setContinueTheseOffer(false)}>
              <CloseRoundedIcon
                fontSize="small"
                sx={{ color: 'gray', cursor: 'pointer' }}
              />
            </IconButton>
          </Grid>

          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Auto Offer Details
            </Typography>
          </Grid>
          <Grid item md={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
                marginTop: '50px',
              }}
            >
              {autoOfferCancelled ? (
                <>
                  Your existing auto offer has been cancelled.
                  <br />
                  Would you like to increase the auto offer? Or delete this auto
                  offer?
                </>
              ) : (
                'Do you want to continue with the existing auto offer details?'
              )}
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? '15px' : 5}
            sx={{ display: 'flex', justifyContent: 'space-between' }}
          >
            <Grid item>
              <Button
                disabled={deleteOfferLoading}
                onClick={() => {
                  setIsEditActionClicked(true);
                  setSummaryView(false);
                  setIsAutoOffer(true);
                  setShowSuccess(true);
                  setEnableAction(false);
                  window.scrollTo({
                    top: 2000,
                    behavior: 'smooth', // Smooth scrolling
                  });
                  setOfferIncreament(
                    formatNumberWithCommas(
                      getBuyerIndividualValue?.PropertyDetails
                        ?.getBuyerLatestOfferDetails?.offerIncrementOne
                    )
                  );
                  setMaximumOffer(
                    formatNumberWithCommas(
                      getBuyerIndividualValue?.PropertyDetails
                        ?.getBuyerLatestOfferDetails?.offermaximumOfferOne
                    )
                  );
                  setContinueTheseOffer(false);
                }}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Edit
              </Button>
            </Grid>
            <Grid
              item
              sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
            >
              <Button
                disabled={deleteOfferLoading}
                onClick={handleCancelAutoOffer}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'capitalize',
                }}
              >
                Delete
              </Button>
              {!autoOfferCancelled && (
                <>
                  <Button
                    disabled={deleteOfferLoading}
                    onClick={() => {
                      setContinueTheseOffer(false);
                      handleMakeOffer();
                    }}
                    variant="outlined"
                    style={{
                      padding: matchessm ? '6px 23px' : '10px 39px',
                      width: '100%',
                      height: matchessm ? '35px' : '41px',
                      fontSize: matchessm ? '12px' : '14px',
                      color: '#FFFFFF',
                      fontWeight: '400',
                      fontFamily: 'Poppins',
                      background: '#4CA4D6',
                      borderRadius: '5px',
                      textTransform: 'capitalize',
                    }}
                  >
                    Continue
                  </Button>
                  {deleteOfferLoading && (
                    <img
                      alt="Logo"
                      src={Loading}
                      className="loaderImage"
                      style={{ height: '40px', width: '40px' }}
                    />
                  )}
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      {/* Focus mode conditional terms popup */}

      <Dialog
        open={focusModeTermsDialogOpen}
        aria-describedby="alert-dialog-slide-description"
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              width: '633px',
              height: '656px',
              borderRadius: '20px',
              padding: '20px',
            },
          },
        }}
      >
        <Grid container sx={{ p: 1 }}>
          <Stack
            direction="row"
            alignItems="center"
            sx={{ width: '100%', position: 'relative', mb: 2 }}
          >
            <IconButton
              sx={{ background: '#F0F0F0', position: 'absolute', left: 0 }}
              onClick={handlecloseFocusModeTerms}
            >
              <ArrowBackIosNewRoundedIcon />
            </IconButton>
            <Typography
              sx={{
                fontFamily: poppins500,
                fontSize: '24px',
                flexGrow: 1,
                textAlign: 'center',
              }}
            >
              Terms
            </Typography>
          </Stack>

          <Divider sx={{ width: '100%', my: 2 }} />
          {(doc66wstatus == 0 || (doc66wstatus == 1 && conditional)) &&
          ((stage == 'ST1'
            ? st1condition?.UnconditionalOnly == 1
            : st2condition?.UnconditionalOnly == 1) ||
            !conditional) ? (
            <>
              <UnConditionalWarningcomponent
                doc66wstatus={doc66wstatus}
                conditional={conditional}
                stage={stage}
                st1condition={st1condition}
                st2condition={st2condition}
                matchessm={matchessm}
                hideOthers={hideOthers}
                matchesmd={matchesmd}
                sharedpage={sharedpage}
                setOpenlogin={setOpenlogin}
                openlogin={openlogin}
                setConditional={setConditional}
                isFocusModeUnConditional
                setConditionalNotAvailable={setConditionalNotAvailable}
                handlecloseFocusModeTerms={handlecloseFocusModeTerms}
                isFocusMode={isFocusMode}
                setOpensolicitorpopup={setOpensolicitorpopup}
                setTypeofsolicitorpopup={setTypeofsolicitorpopup}
                isPause={isPause}
              />
            </>
          ) : (
            <>
              <Grid item sx={{ width: '100%', padding: '0 15px 0 15px' }}>
                <Box
                  sx={{
                    fontFamily: poppins400,
                    fontSize: '14px',
                    mb: 1,
                    color: '#666666',
                  }}
                >
                  {
                    getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                      ?.streetName
                  }
                </Box>
                <Box sx={{ fontFamily: poppins500, fontSize: '20px', mb: 2 }}>
                  Select your Conditional Terms
                </Box>

                <ConditionalTerms
                  makeOfferListArray={makeOfferListArray}
                  hideOthers={hideOthers}
                  setSelectedConditionCodes={setSelectedConditionCodes}
                  setSettlementDays={setSettlementDays}
                  setDepositAmount={setDepositAmount}
                  setStateIndex={setStateIndex}
                  handleClickOpen={handleClickOpen}
                  subtoAddSelected={subtoAddSelected}
                  selectedItems={selectedItems}
                  setSelectedItems={setSelectedItems}
                  setDepAmount={setDepAmount}
                  setSettleDays={setSettleDays}
                  isFocusModeTerms={true}
                  resetTerms={resetTerms}
                  setResetTerms={setResetTerms}
                  saveTerms={saveTerms}
                  setSubtoAddSelected={setSubtoAddSelected}
                  setAdditionalComment={setAdditionalComment}
                  sharedpage={sharedpage}
                />
              </Grid>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  textAlign: 'center',
                  gap: 1,
                  mt: 6,
                  cursor: 'pointer',
                  padding: '0 15px 0 15px',
                }}
              >
                <ResetIcon />
                <Typography
                  onClick={() => setResetTerms(true)}
                  sx={{
                    fontFamily: poppins500,
                    fontSize: '14px',
                    '&:hover': {
                      textDecoration: 'underline',
                    },
                  }}
                >
                  Reset Terms
                </Typography>
              </Box>

              <Grid
                item
                xs={12}
                sx={{
                  display: 'flex',
                  justifyContent: { xs: 'center', sm: 'flex-end' },
                  gap: 2,
                  mt: 4,
                  px: 2,
                  flexWrap: 'wrap',
                }}
              >
                <Button
                  onClick={handlecloseFocusModeTerms}
                  variant="outlined"
                  sx={{
                    minWidth: 140,
                    height: 48,
                    fontFamily: 'Poppins',
                    fontSize: 16,
                    textTransform: 'none',
                    borderRadius: '5px',
                    borderColor: '#D32F2F',
                    color: '#D32F2F',
                    '&:hover': {
                      borderColor: '#B71C1C',
                      backgroundColor: 'rgba(211, 47, 47, 0.04)',
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => {
                    setSaveTerms(true);
                    handlecloseFocusModeTerms();
                  }}
                  variant="contained"
                  sx={{
                    minWidth: 160,
                    height: 48,
                    fontFamily: 'Poppins',
                    fontSize: 16,
                    textTransform: 'none',
                    borderRadius: '5px',
                    backgroundColor: '#6C2AD2',
                    '&:hover': {
                      backgroundColor: '#5A22B5',
                    },
                  }}
                >
                  Save Terms
                </Button>
              </Grid>
            </>
          )}
        </Grid>
      </Dialog>

      {/* Focus mode Unconditional Warning popup */}
      <Dialog
        open={conditionalNotAvailable}
        onClose={() => setConditionalNotAvailable(false)}
        aria-describedby="alert-dialog-slide-description"
        sx={{
          '& .MuiDialog-container .MuiPaper-root': {
            width: 633,
            height: 656,
            borderRadius: '20px',
            padding: '20px',
          },
        }}
      >
        <DialogTitle sx={{ p: 0, mb: 2 }}>
          <Stack
            direction="row"
            alignItems="center"
            sx={{ position: 'relative' }}
          >
            <IconButton
              sx={{ background: '#F0F0F0', position: 'absolute', left: 0 }}
              onClick={() => setConditionalNotAvailable(false)}
            >
              <ArrowBackIosNewRoundedIcon />
            </IconButton>
            <Typography
              sx={{
                fontFamily: poppins500,
                fontSize: 24,
                flexGrow: 1,
                textAlign: 'center',
              }}
            >
              Terms
            </Typography>
          </Stack>
        </DialogTitle>

        <Divider />

        {/* for Focus Mode Warning */}
        <DialogContent sx={{ p: 0, mt: 2 }}>
          <UnConditionalWarningcomponent
            doc66wstatus={doc66wstatus}
            conditional={conditional}
            stage={stage}
            st1condition={st1condition}
            st2condition={st2condition}
            matchessm={matchessm}
            hideOthers={hideOthers}
            matchesmd={matchesmd}
            sharedpage={sharedpage}
            setOpenlogin={setOpenlogin}
            openlogin={openlogin}
            setConditional={setConditional}
            isFocusModeUnConditional
            setConditionalNotAvailable={setConditionalNotAvailable}
            setOpensolicitorpopup={setOpensolicitorpopup}
            setTypeofsolicitorpopup={setTypeofsolicitorpopup}
            isPause={isPause}
          />
        </DialogContent>

        <DialogActions sx={{ px: 2, pb: 2, justifyContent: 'flex-end' }}>
          <Button
            variant="outlined"
            sx={{
              px: 4,
              height: 41,
              fontSize: 14,
              color: '#666',
              fontWeight: 400,
              fontFamily: 'Poppins',
              border: '1px solid rgba(17, 35, 71, 0.1)',
              borderRadius: '5px',
              textTransform: 'capitalize',
            }}
            onClick={() => setConditionalNotAvailable(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <SubmitOfferPopup
        openCard={openCard}
        setOpenCard={setOpenCard}
        isLoading={isLoading}
        isLoader={isLoader}
        stage={stage}
        groupCall={groupCall}
        groupIt={groupIt}
        matchessm={matchessm}
        matchesmd={matchesmd}
        isSmallHeight={isSmallHeight}
        setIsLoading={setIsLoading}
        setIsLoader={setIsLoader}
        array={array}
        getBuyerIndividualValue={getBuyerIndividualValue}
        userDetail={userDetail}
        totalAmount={totalAmount}
        formatTime={formatTime}
        currentTime={currentTime}
        formatDate={formatDate}
        showTick={showTick}
        setShowTick={setShowTick}
        openBox={openBox}
        setOpenBox={setOpenBox}
        makeOffer={makeOffer}
        confirmCancel={confirmCancel}
        setConfirmCancel={setConfirmCancel}
        setAcceptterms={setAcceptterms}
        setOfferExp={setOfferExp}
        setIsBestOffer={setIsBestOffer}
        setSelectedItems={setSelectedItems}
        setIsAutoOffer={setIsAutoOffer}
        setTotalAmount={setTotalAmount}
        setMaximumOffer={setMaximumOffer}
        setOfferIncreament={setOfferIncreament}
        setSubtoAddSelected={setSubtoAddSelected}
        setSelectedConditionCodes={setSelectedConditionCodes}
        selectedConditionCodes={selectedConditionCodes}
        addictionComment={addictionComment}
        matches700={matches700}
        settlementDays={settlementDays}
        depositAmount={depositAmount}
        conditional={conditional}
        offersOnly={offersOnly}
        setOffersOnly={setOffersOnly}
        makeOfferresponse={makeOfferresponse}
        settleDays={settleDays}
        depAmount={depAmount}
        formatDateTimeSydney={formatDateTimeSydney}
      />
      {openBox && (
        <ConfirmingParticipationStageTwo
          openConfirmingPopup={openBox}
          setOpenConfirmingPopup={setOpenBox}
          getBuyerIndividualValue={getBuyerIndividualValue}
          groupIt={groupIt}
          groupCall={groupCall}
          matches700={matches700}
          matchessm={matchessm}
          acceptterms={acceptterms}
          setAcceptterms={setAcceptterms}
          setTotalAmount={setTotalAmount}
          setSelectedItems={setSelectedItems}
          setOfferExp={setOfferExp}
          setIsBestOffer={setIsBestOffer}
          setIsAutoOffer={setIsAutoOffer}
          setMaximumOffer={setMaximumOffer}
          setOfferIncreament={setOfferIncreament}
          setSubtoAddSelected={setSubtoAddSelected}
          setSelectedConditionCodes={setSelectedConditionCodes}
          openCard={openCard}
          setOpenCard={setOpenCard}
          fromMakeOffer={true}
        />
      )}
      <IdenticalSuggestion
        open={identicalsuggestion}
        onClose={() => {
          setIdenticalsuggestion(false);
          makeOffer(0, 1);
        }}
        matchessm={matchessm}
        matchesmd={matchesmd}
        makeOfferresponse={makeOfferresponse}
        address={
          getBuyerIndividualValue?.PropertyDetails?.propertyAddress?.streetName
        }
        proceed={() => {
          setTotalAmount(makeOfferresponse?.suggestedPrice);
          setIdenticalsuggestion(false);
          setOpenCard(false);
          setIsLoading(true);
          setIsLoader(false);
          setShowTick(false);
        }}
      />

      {openCampaignRestrictedPopup && (
        <CampaignRestrictedPopup
          open={openCampaignRestrictedPopup}
          setOpen={setOpenCampaignRestrictedPopup}
          agentBuyerBinderId={agentBuyerBinderId}
        />
      )}
    </>
  );
};

export const UnConditionalWarningcomponent = (props) => {
  const {
    doc66wstatus,
    conditional,
    stage,
    st1condition,
    st2condition,
    matchessm,
    hideOthers,
    matchesmd,
    sharedpage,
    setOpenlogin,
    openlogin,
    setConditional,
    isFocusModeUnConditional,
    setConditionalNotAvailable,
    handlecloseFocusModeTerms,
    isFocusMode,
    setOpensolicitorpopup,
    setTypeofsolicitorpopup,
    isPause,
  } = props;
  return (
    <>
      {(doc66wstatus == 0 || (doc66wstatus == 1 && conditional)) &&
        ((stage == 'ST1'
          ? st1condition?.UnconditionalOnly == 1
          : st2condition?.UnconditionalOnly == 1) ||
          !conditional) && (
          <Box sx={{ display: matchessm && 'none' }}>
            <Stack
              flexDirection={'column'}
              sx={{ display: hideOthers && 'none' }}
            >
              <Stack marginTop={!matchessm && '30px'} marginLeft={'25px'}>
                <Typography
                  sx={{
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '300 !important',
                    fontSize:
                      matchesmd || isFocusModeUnConditional ? '16px' : '20px',
                    color: '#000000',
                  }}
                >
                  {conditional
                    ? 'Conditional offer is not available for this campaign'
                    : 'Unconditional offer is not yet available'}
                </Typography>
              </Stack>
              <Stack>
                <Stack flexDirection={'row'}>
                  <Typography
                    sx={{
                      fontFamily: 'Poppins !important',
                      fontStyle: 'normal !important',
                      fontWeight: '400 !important',
                      fontSize:
                        matchesmd || isFocusModeUnConditional ? '16px' : '20px',
                      color: '#000000',
                      marginLeft: '25px',
                    }}
                  >
                    Next Step Required:
                  </Typography>
                  <Stack
                    marginLeft={'6px'}
                    sx={{ cursor: isPause ? 'not-allowed' : 'pointer' }}
                    onClick={() => {
                      if (isPause) return;

                      if (sharedpage) {
                        setOpenlogin(!openlogin);
                      } else {
                        if (doc66wstatus == 0) {
                          if (isFocusModeUnConditional) {
                            setConditionalNotAvailable(false);
                          }
                          setTypeofsolicitorpopup('request66w');
                          setOpensolicitorpopup(true);
                        } else {
                          setConditional(!conditional);
                          if (isFocusMode) {
                            handlecloseFocusModeTerms();
                          }
                        }
                      }
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '300 !important',
                        fontSize:
                          matchesmd || isFocusModeUnConditional
                            ? '16px'
                            : '20px',
                        color: '#0087D2',
                      }}
                    >
                      {doc66wstatus == 1 && conditional
                        ? 'Please choose unconditional offer'
                        : conditional
                        ? 'Please Complete s66W Certificate for giving unconditional offer'
                        : 'Please Complete s66W Certificate'}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            </Stack>
            {!conditional && (
              <Stack
                sx={{
                  maxWidth: '1026px',
                  minHeight: '172px',
                  border: ' 1px solid #965CF0',
                  borderRadius: '10px',
                  backgroundColor: '#FFFFFF',
                  margin: '20px',
                  padding: '20px',
                  display: hideOthers && 'none',
                }}
              >
                <Stack flexDirection={'row'}>
                  {!matchessm && (
                    <Stack
                      marginTop={'25px'}
                      marginLeft={isFocusModeUnConditional ? '5px' : '45px'}
                    >
                      <Sound
                        width={isFocusModeUnConditional ? '100px' : '148.69px'}
                        height={isFocusModeUnConditional ? '70px' : '112px'}
                      />
                    </Stack>
                  )}

                  <Stack
                    sx={{
                      marginLeft:
                        !matchessm || (!isFocusModeUnConditional && '50px'),
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '600 !important',
                        fontSize:
                          matchesmd || isFocusModeUnConditional
                            ? '16px'
                            : '20px',
                        color: '#112347',
                      }}
                    >
                      Did you know?
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'normal !important',
                        fontWeight: '300 !important',
                        fontSize:
                          matchesmd || isFocusModeUnConditional
                            ? '16px'
                            : '20px',
                        color: '#112347',
                      }}
                    >
                      Unconditional offers are 61% more likely to be accepted by
                      an owner.
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins !important',
                        fontStyle: 'italic!important',
                        fontWeight: '400 !important',
                        fontSize:
                          matchesmd || isFocusModeUnConditional
                            ? '16px'
                            : '20px',

                        color: '#6C2AD2',
                      }}
                    >
                      Find out how to submit an Unconditional Offer
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
            )}
          </Box>
        )}
    </>
  );
};
